/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'I MIEI VIDEO SHORTS',
    see_more: 'VEDI DI PIÙ',
    no_shorts_found: 'Nessuno Shorts trovato',
    shorts: 'Shorts',
    general_information: 'Informazioni generali',
    gamification: 'Gamification',
    click_to_select_files: 'Clicca per selezionare i file',
    selected_files: 'File selezionati',
    uploaded: 'Caricato',
    failed: 'Fallito',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Il sistema analizzerà automaticamente e selezionerà i documenti più pertinenti dalla libreria della tua organizzazione in base ai requisiti dei contenuti.',
    select_from_library: ' Seleziona dalla libreria',
    search_document: 'Cerca documenti...',
    selected: 'Selezionato',
    loading_documents: 'Caricamento documenti...',
    review_generated_content: 'Revisiona i contenuti generati',
    confirm_and_replace_content: 'Conferma e sostituisci i contenuti',
    the_generate_content_will_replace:
      'I contenuti generati sostituiranno il testo esistente sulle pagine selezionate. Se non vuoi applicare queste modifiche, puoi tornare al passaggio precedente.',
    pages_to_be_updated: 'Pagine da aggiornare',
    generated_revisions: 'Revisioni generate',
    lesson_preview: 'Anteprima lezione',
    create_new_folder: 'Crea nuova cartella',
    rename_item: 'Rinomina elemento',
    enter_folder_name: 'Inserisci il nome della cartella:',
    enter_new_name: 'Inserisci il nuovo nome:',
    folder_name: 'Nome cartella:',
    new_name: 'Nuovo nome',
    move_items: 'Sposta elementi',
    copy_items: 'Copia elementi',
    move_here: 'Sposta qui',
    copy_here: 'Copia qui',
    select_destination_library_and_folder:
      'Seleziona libreria di destinazione e cartella:',
    items_selected: 'Elementi selezionati',
    version: 'Versione',
    modified_by: 'Modificato da',
    size: 'Dimensione',
    restore: 'Ripristina',
    are_you_sure_you_want_to_restore_this_version:
      'Sei sicuro di voler ripristinare questa versione?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Questo sostituirà la versione corrente con quella selezionata.',
    restore_this_version: 'Ripristina questa versione',
    restore_not_available: 'Ripristino non disponibile',
    version_history: 'Cronologia versioni:',
    by_making_items_public:
      'Rendendo gli elementi pubblici, saranno visibili a tutti. Si prega di leggere termini e condizioni prima di procedere.',
    the_selected_items_will_be_copied:
      'Gli elementi selezionati saranno copiati nella tua libreria pubblica e saranno visibili a tutti.',
    the_selected_items_will_be_copied_to_org:
      'Gli elementi selezionati saranno copiati nella libreria della tua organizzazione e saranno visibili a tutti i membri dell’organizzazione.',
    the_selected_items_will_be_copied_to_your_private:
      'Gli elementi selezionati saranno copiati nella tua libreria privata e saranno visibili solo a te.',
    loading_organization: 'Caricamento utenti dell’organizzazione...',
    click_download_to_view: 'Clicca su "Scarica" per visualizzare',
    archive_file: 'File archivio',
    no_preview_available: 'Anteprima non disponibile',
    audit_report: 'Rapporto di audit',
    audit_type: 'Tipo di azione',
    i_agree_to_the_terms_and_conditions: 'Accetto i termini e le condizioni.',
    this_file_is_indexed_for_ai: 'Questo file è indicizzato per AI.',
    file_is_not_indexed_for_ai: 'Il file non è indicizzato per AI.',
    no_users_found: 'Nessun utente trovato',
    no_users_available: 'Nessun utente disponibile',
    add_people: 'Aggiungi persone',
    people: 'Persone',
    access_type: 'Tipo di accesso',
    no_group_found: 'Nessun gruppo trovato',
    add_group: 'Aggiungi gruppo',
    groups: 'Gruppi',
    users_top: 'Utenti',
    confirm_delete: 'Conferma eliminazione',
    do_you_want_remove: 'Sei sicuro di voler rimuovere',
    form_this_documents_permissions: 'da queste autorizzazioni del documento?',
    no_users_found_in_this_group: 'Nessun utente trovato in questo gruppo',
    add_selected_users: 'Aggiungi utenti selezionati',
    choose_users_from_the_list: 'Scegli utenti dalla lista',
    selected_users: 'Utenti selezionati',
    archived: 'Archiviato',
    request_approval: 'Richiedi approvazione',
    document_in_review: 'Documento in revisione',
    approve: 'Approva',
    reject: 'Rifiuta',
    comment: 'Commento:',
    enter_your_commit: 'Inserisci il tuo commento...',
    confirm_cancel: 'Conferma annullamento',
    upload_3d_zip: 'Carica 3D Zip',
    delete_items: 'Elimina elementi',
    video_upload_request: 'Richiesta caricamento video',
    reject_video: 'Rifiuta video',
    enter_rejection_reason: 'Inserisci motivo del rifiuto...',
    please_provide_a_reason_for_reejection_this_video:
      'Fornisci un motivo per rifiutare questo video:',
    generate_trivia_with_ai: 'Genera Trivia con AI',
    select_category: 'Seleziona categoria:',
    number_of_question: 'Numero di domande',
    generated_questions: 'Domande generate',
    this_will_clear_all_generate_question:
      'Questo cancellerà tutte le domande generate. Continuare?',
    sure_delete: 'Sei sicuro di voler eliminare?',
    delete_this_question: 'Sei sicuro di voler eliminare questa domanda?',
    loading_quiz: 'Caricamento quiz...',
    creteing_file: 'Creazione file in corso',
    opening_desktop_app: 'Apertura app desktop...',
    this_folder_is_empty: 'Questa cartella è vuota',
    select_a_competition: 'Seleziona una competizione...',
    activity_badges: 'Badge attività',
    awarded_every_badges:
      'Assegnato ogni 4, 8, 16, 32, 64, 128, 256, 512 accessi',
    learning_badges: 'Badge apprendimento',
    awarded_every_courses:
      'Assegnato ogni 1, 4, 8, 16, 32, 64, 128 corsi completati',
    test_badges: 'Badge test',
    awarded_every_passes_tests:
      'Assegnato ogni 2, 4, 8, 16, 32, 64, 128, 256 test superati',
    assignment_badges: 'Badge compiti',
    awarded_every_passed_assignments:
      'Assegnato ogni 1, 2, 4, 8, 16, 32, 64, 128 compiti superati',
    perfectionism_badges: 'Badge perfezionismo',
    awarded_every_assignments_with_scrore:
      'Assegnato ogni test o compito con punteggio 90%+',
    communication_badges: 'Badge comunicazione',
    awarded_every_topics_or_comments:
      'Assegnato ogni 2, 4, 8, 16, 32, 64, 128, 256 argomenti o commenti',
    certification_badges: 'Badge certificazione',
    awarded_every_certificates:
      'Assegnato ogni 1, 2, 4, 8, 16, 32, 64, 128 certificati',
    level_name: 'Nome livello',
    delete_competition: 'Elimina competizione',
    this_week: 'Questa settimana',
    this_year: 'Quest’anno',
    make_organization: 'Rendi organizzazione',
    no_results_found: 'Nessun risultato trovato per',
    no_items_available: 'Nessun elemento disponibile',
    help_video: 'Video di aiuto',
    select_a_video_from_the_list:
      'Seleziona un video dalla lista per iniziare a imparare'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Trascina i file e seleziona un luogo per caricare.',
    duplicate_lessoon: 'Questa lezione è già presente nel corso',
    skill_rule_title:
      'Per favore inserisci il titolo del percorso di competenze',
    imageCreatorTitle: 'Creatore di immagini',
    isTranslated: 'Tradotto',
    translationCourseDesc:
      'La traduzione di questo corso potrebbe richiedere qualche minuto. Grazie per la pazienza!',
    translateCourseTip:
      "Crea un corso tradotto che puoi modificare liberamente indipendentemente dall'originale, includendo tutte le lezioni e le pagine.",
    translateModalBtn: 'Traduci',
    translationSuccess: 'Il corso "<0/>" è stato tradotto con successo!',
    translatingCourse: 'Traduzione del corso in corso...',
    translateModalTitle: 'Traduci corso',
    translateSelectLang: 'Seleziona lingua',
    fileDeleteconfirm:
      'Sei sicuro di voler eliminare questo file? Questa azione non può essere annullata.',
    fileDeleteMessage: 'File eliminato con successo.',
    fileDeleteFailedMessage: 'Eliminazione del file fallita!',
    fileDelete: 'Elimina questo file.',
    certificate_save_btn: 'Aggiungi certificato',
    maze_path_info: 'Nessun percorso disponibile per il grafo!',
    file_size_mb: 'La dimensione del file deve essere inferiore a 25 MB!',
    reports: {
      products: 'Prodotti',
      users: 'Utenti',
      ph_username: 'Cerca per nome utente',
      ph_id: 'Cerca per ID utente',
      ph_email: 'Cerca per email utente'
    },
    select_upload_section_id: 'Sezione file richiesta',
    tags_all: 'Tutti',
    delete_file_confirm: 'Sei sicuro di voler eliminare questo file?',
    delete_file_title: 'Elimina file',
    tooltip_publish: "Pubblica il corso con l'opzione selezionata",
    tooltip_save: "Salva il corso con l'aggiornamento corrente",
    tooltip_next: 'Vai alla prossima impostazione del corso',
    tooltip_finish: "Completa e salva l'aggiornamento corrente",
    stories_modal: {
      title_upload: 'Carica storie',
      title_update: 'Aggiorna storie',
      title_audio: 'File audio della storia',
      btn_upload: 'Carica',
      btn_update: 'Aggiorna',
      btn_close: 'Chiudi',
      btn_cancel: 'Annulla',
      lbl_cover: 'Copertina della storia',
      rule_cover: 'Per favore carica una copertina audio per la storia!',
      lbl_title: 'Titolo audio della storia',
      rule_title: 'Per favore inserisci il titolo audio della storia!',
      lbl_description: 'Descrizione audio della storia',
      rule_description:
        'Per favore inserisci la descrizione audio della storia!',
      lbl_file: 'Carica file audio della storia',
      rule_file: 'Per favore carica un file audio della storia!',
      rule_file_type: 'Per favore carica un file audio valido per la storia!',
      lbl_select_file: 'Seleziona file audio della storia',
      msg_valid_file:
        'Per favore seleziona un file audio valido per la storia!',
      msg_success: 'File audio della storia caricato con successo',
      msg_failed: 'Impossibile assegnare i dati multimediali!',
      msg_error: 'Errore durante il caricamento del file!'
    },
    audio_modal: {
      title_upload: 'Carica',
      title_update: 'Aggiorna',
      title_audio: 'File audio',
      btn_upload: 'Carica',
      btn_update: 'Aggiorna',
      btn_close: 'Chiudi',
      btn_cancel: 'Annulla',
      lbl_cover: 'Copertina audio',
      rule_cover: 'Per favore carica una copertina audio!',
      lbl_title: 'Titolo audio',
      rule_title: 'Per favore inserisci il titolo audio!',
      lbl_description: 'Descrizione audio',
      rule_description: 'Per favore inserisci la descrizione audio!',
      lbl_file: 'Carica file audio',
      rule_file: 'Per favore carica un file audio!',
      rule_file_type: 'Per favore carica un file audio valido!',
      lbl_select_file: 'Seleziona file audio',
      msg_valid_file: 'Per favore seleziona un file audio valido!',
      msg_success: 'File audio caricato con successo',
      msg_failed: 'Impossibile assegnare i dati multimediali!',
      msg_error: 'Errore durante il caricamento del file!'
    },
    info_episode: "Copertina per l'episodio.",
    btn_delete_episode: 'Elimina questo episodio del podcast.',
    btn_edit_marketplace: 'Modifica dettagli del marketplace.',
    btn_save_marketplace: 'Salva le modifiche correnti.',
    btn_ai_podcast: 'Crea episodio podcast con AI.',
    btn_upload_podcast: 'Carica il tuo episodio audio podcast.',
    attach_file:
      'Carica file per condividere più contenuti con il tuo pubblico',
    fileDownload: 'Scarica questo file.',
    singleEpishode: 'Episodio',
    podcast_music: 'Podcast, musica e storie',
    publishHeader: 'Pubblica podcast, musica e storie',
    editHeader: 'Modifica podcast, musica e storie',
    createHeader: 'Crea podcast, musica e storie',
    marketplaceHeader: 'Dettagli marketplace di podcast, musica e storie',
    message_marketplace: 'Per favore completa il modulo del marketplace!',
    create_podcast_live: 'Podcast e musica live',
    create_podcast_custom: 'Podcast e musica personalizzati',
    create_podcast_stories: 'Storia',
    ai_Assisted_podcast_reation: 'Podcast e musica assistiti da AI',
    publishTitle: 'Pubblica podcast, musica e storie per un pubblico pubblico.',
    customButton: 'Crea personalizzato',
    customTitle: 'Salva le modifiche apportate al podcast.',
    updateButton: 'Aggiorna',
    createButton: 'Crea',
    createNewButton: 'Crea nuovo',
    updateTitle: "Aggiorna dettagli dell'attuale podcast, musica e storie.",
    createTitle: 'Crea un nuovo podcast, musica e storie',
    createNewTitle:
      "Un nuovo podcast, musica e storie saranno creati con i nuovi dettagli immessi rispetto all'attuale podcast, musica e storie.",
    podcastTitle: 'Elenco episodi',
    podcastStoryTitle: 'Elenco episodi delle storie',
    podcastToolTipTitle: 'Elenco episodi podcast',
    uploadAudio: 'Carica',
    aiAudio: 'Audio AI',
    emptyPodcast:
      'Non ci sono ancora registrazioni audio di podcast, musica e storie.',
    emptyStoriesPodcast: 'Non ci sono ancora storie aggiunte.',
    emptyCreatePodcast: 'Per favore crea un podcast per aggiungere audio.',
    playPodcast: 'Riproduci il podcast, la musica e le storie selezionate.',
    pausePodcast:
      'Metti in pausa il podcast, la musica e le storie selezionate.',
    selectPodcast: 'Seleziona questo podcast, musica e storie.',
    downloadPodcast: 'Scarica questo audio.',
    uploadAudioFile: 'Carica un nuovo audio e sostituisci quello attuale.',
    deleteConfirm: 'Sei sicuro di voler eliminare questo audio?',
    roomName: 'Nome podcast',
    addGuestTitle: 'Aggiungi ospite',
    showTime: 'Tempo di visualizzazione',
    startTime: 'Ora di inizio',
    endTime: 'Ora di fine',
    erorMsgImg: "Per favore seleziona un'immagine valida.",
    failedMsgImg: 'Caricamento immagine fallito. Per favore riprova!',
    failedMsgUpload: 'Caricamento copertina fallito!',
    btnCoverUpload: 'Carica copertina',
    is_private: 'Privato',
    to_attach: 'Allega File',
    file_attached: 'File Allegato(i)',
    main_event: 'Evento Principale',
    event: 'Eventi',
    upload_pdf: 'Carica PDF',
    portrait: 'Ritratto',
    landscape: 'Paesaggio',
    import_from_library: 'Importa Testo dalla Libreria Media',
    question_answer_ai: 'Domanda/Risposta AI',
    take_maze: 'Prendi MetaMaze',
    training: 'Formazione',
    select_transcribe_locale: 'Seleziona Lingua per la Trascrizione',
    transcribe_limit: 'Inserisci Minuti di Trascrizione',
    not_complete: 'Informazioni Marketplace Non Complete',
    complete: 'Informazioni Marketplace Complete',
    not_admin:
      'Privilegi Amministrativi Necessari per Pubblicare nel Marketplace',
    no_course:
      'Inserisci Titolo e Seleziona un’Immagine per Abilitare il Marketplace',
    scorm_not_complete:
      'Inserisci Titolo e Seleziona un’Immagine per Caricare il File SCORM',
    not_found_maze: 'MetaMaze Non Trovato',
    email_require: 'Email Richieste',
    poll_required: 'Dati del Sondaggio Richiesti',
    alert: 'Avviso!',
    warning: 'Attenzione!',
    ok: 'Ok',
    cancel: 'Annulla',
    done: 'Fatto',
    insert: 'Inserisci',
    private: 'Privato',
    public: 'Pubblico',
    no_connection: 'Connessione Internet Persa',
    switch: 'Cambia',
    share_screen: 'Condividi Schermo',
    stop_share_screen: 'Interrompi Condivisione Schermo',
    share_screen_with_camera: 'Condividi Schermo con Camera',
    stop_share_screen_with_camera: 'Interrompi Condivisione Schermo con Camera',
    camera_on: 'Camera Accesa',
    camera_off: 'Camera Spenta',
    mic_on: 'Disattiva Muto',
    mic_off: 'Attiva Muto',
    fullscreen: 'Schermo Intero',
    live_now: 'In Diretta Ora',
    schedule_on: 'Pianifica per',
    organisations: 'Organizzazioni',
    org_groups: 'Gruppi Organizzazione',
    specific_user: 'Utente Specifico',
    gif: 'GIF',
    unavailable: 'Non Disponibile',
    yes: 'Sì',
    no: 'No',
    event_duration_message: 'Massimo 300 minuti (5 ore)',
    send_email: 'Invia Notifica Email',
    admin_only: 'Solo Admin',
    join: 'Partecipa',
    leave: 'Esci',
    share: 'Condividi',
    share_text:
      'Digita l’indirizzo email della persona con cui vuoi condividere questo file.',
    share_text_title: 'Condividi PDF',
    share_text_title_txt: 'Condividi Testo',
    select_users: 'Seleziona Utenti',
    delete: 'Elimina',
    attachment_event: 'Allegati per l’evento:',
    transcribe_limit: 'Minuti di Trascrizione',
    monthly_transcribe: 'Limite Mensile di Trascrizione:',
    enable_ai: 'Abilita AI:',
    enable_maze: 'Abilita MetaMaze:',
    media_service: 'Servizio Media',
    allow_others: 'Permetti agli Altri di Modificare',
    join_breakout_room: 'Entra nella Stanza Breakout',
    bio: 'Bio',
    linkedin: 'LinkedIn',
    select_org_report:
      'Trova e scegli un’organizzazione per generare il report.',
    org_image_not_found: 'Immagine Non Trovata',
    insert_text: 'Inserisci Testo',
    insert_question_answer: 'Domanda/Risposta AI',
    modal_title2: 'Galleria Testi',
    my_text_library: 'La Mia Libreria Testi',
    ai: 'AI',
    public_text_library: 'Libreria Testi Pubblica',
    organization_text_library: 'Libreria Testi Organizzazione',
    no_transcribed_text: 'Nessun Testo Trascritto Trovato',
    public_text_not_found: 'Testo Trascritto Pubblico Non Trovato',
    org_text_not_found: 'Testo Trascritto Organizzazione Non Trovato',
    org_video_not_found: 'Video Non Trovato',
    canva: 'Fallo da Canva',
    canva_open: 'Clicca qui per aprire l’editor di Canva.',
    pdf: 'PDF',
    txt: 'TESTO',
    human: 'Premium',
    shared_file: 'Il tuo file è stato condiviso con successo.',
    error_shared_file:
      'Si è verificato un problema con la condivisione del file. Per favore riprova.',
    publish: 'Pubblica',
    maze_scenes: 'Scene MetaMaze',
    pexel_images: 'Immagini Pexel',
    group: 'Gruppo',
    group_name: 'Nome Gruppo',
    select_group: 'Seleziona Gruppo',
    search_maze: 'Cerca MetaMaze',
    hosts: 'Host',
    avg_score: 'Punteggio Percentuale',
    maze_report: 'Rapporto del Maze',
    maze_view: 'Vista del Maze',
    title_maze: 'MetaMaze',
    author: 'Autore',
    match: 'Corrispondenza Percorso',
    preview_mazeTitle: 'Titolo: ',
    other: 'Altro',
    total: 'TOTALE',
    report_course: 'CORSO',
    report_courses: 'CORSI',
    report_event: 'EVENTO',
    report_events: 'EVENTI',
    report_maze: 'MAZE',
    report_personalize_learning: 'APPRENDIMENTO PERSONALIZZATO',
    report_live_assessment: 'VALUTAZIONE IN DIRETTA',
    report_live_assessments: 'VALUTAZIONI IN DIRETTA',
    report_skill_journey: 'PERCORSO DI COMPETENZE',
    skill_journey: 'Percorso di Competenze',
    skill_journeys: 'Percorsi di Competenze',
    date: 'DATA: ',
    search_people: 'Cerca Persone',
    passed: 'SUPERATO',
    failed: 'NON SUPERATO',
    item: 'ELEMENTO',
    type: 'TIPO',
    minimum_pass_score: 'PUNTEGGIO MINIMO PER SUPERARE',
    resources_count: 'CONTEGGIO RISORSE',
    back: 'INDIETRO',
    resources: 'RISORSE',
    time_spent: 'TEMPO TRASCORSO (MINUTI)',
    detail: 'DETTAGLIO',
    watched_time_mins: 'TEMPO VISIONATO (MINUTI)',
    personalize_learning: 'Apprendimento Personalizzato',
    result: 'Risultato',
    assessment_title: 'Titolo',
    marketPlace_graph: 'Grafico Marketplace',
    attachments: 'Allegati Aggiuntivi',
    new_scorm_course: 'Carica un Nuovo Corso SCORM',
    upload_scorm_course: 'Carica Corso SCORM',
    new_maze: 'Crea un Nuovo MetaMaze',
    new_skill_journey: 'Crea un Percorso di Competenze',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Percorso di Competenze',
    new_discussion_room: 'Crea un Nuovo Podcast',
    title: 'Cosa vuoi fare oggi?',
    build_course: 'Crea il Mio Corso',
    live_broadcast: 'Trasmissione in Diretta',
    invite_users: 'Invita Utenti alla Mia Organizzazione',
    build_voice_over: 'Crea la Mia Voce Fuoricampo',
    view_reports: 'Visualizza Rapporti',
    upload_media: 'Carica i Miei Media o Lavori e Condividili',
    main_menu: 'Menu Principale',
    get_started: 'INIZIA',
    search_group: 'Cerca Gruppo Organizzazione',
    ai_course: 'Corso AI',
    search_user: 'Cerca Nome Azienda',
    no_maze: 'Attualmente non ci sono MetaMaze.',
    conference_event_title: 'Eventi Conferenza',
    conference_event_subTitle: 'Eventi Conferenza Terminati',
    conference_event: 'Attualmente non ci sono eventi conferenza.',
    no_skill: 'Attualmente non ci sono percorsi di competenze.',
    no_podcast: 'Attualmente non ci sono podcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Valutazioni Live Passate',
    no_live_assessment: 'Attualmente non ci sono valutazioni live.',
    enrolled_courses: 'Corsi',
    my_video_channel: 'I Miei Canali Video',
    enrolled_liveEvents: 'Eventi Live',
    sharebot: 'Sharebot',
    selected_language: 'Lingua Selezionata',
    shareSphere_game: 'Gioco ShareSphere',
    maze: 'MetaMaze',
    skill: 'Percorso di Competenze',
    channel: 'Canale',
    order: 'Ordine',
    is_record: 'Registra',
    no_maze_found: 'Nessun MetaMaze trovato.',
    maze_self_limit_reached: 'Limite di autovalutazione MetaMaze raggiunto.',
    metamaze_two_times: 'Hai già completato questo MetaMaze 2 volte.',
    metamaze_two_times_no_result:
      'Hai già completato questo MetaMaze 2 volte. Il tuo risultato non sarà tracciato dopo la seconda volta.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Punteggio minimo per superare',
    organization: "Seleziona un'Organizzazione",
    pass_score_mark: 'Inserisci un punteggio tra 1 e 100',
    maze_cloning_success: 'MetaMaze "<0/>" clonato con successo!',
    create_certificate: 'Crea un Certificato',
    create_badge: 'Crea un Badge',
    certificate_added: 'Certificato aggiunto.',
    badge_added: 'Badge aggiunto.',
    certificate_warning:
      'Non puoi modificare il certificato/badge una volta pubblicato!',
    created_course_plan:
      'Modifica e pubblica il tuo corso creato e pianifica eventi live',
    market_place_space: 'Marketplace',
    select_course_language: 'Seleziona lingua (Opzionale)',
    select_language: 'Seleziona lingua',
    file_upload: 'Carica file',
    text: 'Scrivi qui…',
    attempts_count: 'Numero di tentativi consentiti per utente',
    no_of_people_placeholder: 'Numero di persone',
    back_to_maze: 'Torna allo scenario MetaMaze',
    edit_maze: 'Modifica Maze',
    wait: 'Attendere...',
    retry: 'Riprova',
    publish_scorm_course: 'Pubblica il tuo corso SCORM',
    publish_maze: 'Pubblica il tuo MetaMaze',
    import: 'Importa elementi',
    answer_correct: 'Scegli la risposta corretta',
    author_name: "Inserisci il nome dell'autore",
    select_category: 'Seleziona una categoria',
    course_outline: 'Inserisci il programma del corso',
    course_obj: 'Inserisci gli obiettivi del corso',
    course_description: 'Inserisci la descrizione del corso',
    maze_outline: 'Inserisci il programma del labirinto',
    maze_obj: 'Inserisci gli obiettivi del labirinto',
    maze_description: 'Inserisci la descrizione del labirinto',
    lessons: 'Inserisci il numero di lezioni',
    user_email_require: "L'email dell'utente è obbligatoria",
    team_size: 'La dimensione del team è obbligatoria',
    enter_price: 'Inserisci un prezzo (5 o più)',
    input_title_maze: 'Inserisci il titolo del labirinto',
    trainer_bio: 'Inserisci la biografia del formatore',
    trainer_linkedin: 'Inserisci il LinkedIn del formatore',
    error_video: 'Inserisci il numero di video',
    input_video_link: 'Inserisci il link del video',
    number_of_video: 'numero di video',
    number_of_lessions: 'numero di lezioni',
    no_of_people_in_conference: 'Quante persone ci sono nella conferenza?',
    transcribe_settings: 'Impostazioni di trascrizione',
    transcribe: 'Trascrivi',
    cloning_maze: 'Clonazione del MetaMaze...',
    id_number: 'Numero ID',
    timezone: 'Fuso orario',
    edit_maze: 'Modifica',
    delete_maze: 'Elimina',
    view_maze: 'Visualizza',
    create_metamaze: 'Crea un MetaMaze',
    metamaze_scenario: 'Scenario MetaMaze',
    publish_metamaze: 'Impostazioni di pubblicazione',
    search_result: 'Risultati della ricerca:',
    search_for: 'Cerca',
    search_no_result: '- Nessun risultato disponibile!',
    channel_no_available: 'Nessun canale disponibile!',
    this_card: 'Questa è una scheda',
    course_no_available: 'Nessun corso disponibile!',
    exit_fullscreen: 'Esci da schermo intero',
    bg_image: 'Immagine di sfondo',
    introduction: 'Introduzione',
    summary: 'Sommario',
    generate_introduction: 'Genera introduzione',
    generate_summary: 'Genera sommario',
    bullet_points: 'Punti elenco',
    title_simulation: 'Inserisci il nome della simulazione',
    view_generated_images: 'Visualizza le immagini generate',
    image_transparency: 'Trasparenza immagine',
    template_bg_color: 'Colore di sfondo del modello',
    select_template_layout: 'Seleziona un layout modello',
    reload_template: '(Ricarica modelli)',
    are_you_sure_want_close: 'Sei sicuro di voler chiudere?',
    all_your_changes_will_be_lost: 'Tutte le modifiche andranno perse.',
    please_checked_before_generated_video:
      'Conferma che tutte le condizioni siano selezionate prima di generare un video.',
    voice_must_be_selected: 'È necessario selezionare una voce',
    avatar_must_be_selected: 'È necessario selezionare un avatar.',
    maximum_five_slides_try_again:
      "Errore nell'estrazione delle immagini dal file. Assicurati che ci siano al massimo 5 diapositive e che ci siano note in ciascuna. Riprova!",
    back_to_upload: 'Torna al caricamento',
    uploading_file_to_server: 'Caricamento del file sul server in corso',
    extracting_images_from_your_file: 'Estrazione delle immagini dal file',
    upload_your_ppt_or_drag:
      'Carica il file della presentazione (.PPTX) o trascinalo qui.',
    maximum_five_slides_error:
      'Assicurati che il file PowerPoint contenga al massimo 5 diapositive con note. Altrimenti si verificherà un errore.',
    number_of_questions_generated: 'Numero di domande generate',
    quiz_page_this_cannot_be_done:
      'Sei sicuro di voler aggiungere il quiz a questa pagina? Questa azione non può essere annullata.',
    confirm_selection: 'Conferma selezione',
    select_quiz_page: 'Seleziona pagina del quiz',
    lesson_do_you_want_add_this_quiz:
      'A quale parte della lezione vuoi aggiungere questo quiz?',
    beginning_of_lesson: "All'inizio della lezione",
    end_of_lesson: 'Alla fine della lezione',
    currently_active_page: 'Pagina attualmente attiva',
    finish: 'Fine',
    upload_selection_file: 'Carica file della sezione',
    general_quiz: 'Quiz Generale',
    manage_sequence: 'Gestisci sequenza',
    save_sequence: 'Salva sequenza',
    new: 'Nuovo',
    in_progress: 'In corso',
    recommended_course: 'Corso consigliato',
    up_coming: 'Prossimi',
    past_live: 'Live precedenti',
    input_your_channel_name: 'Inserisci il nome del canale!',
    organization_place: "Marketplace dell'organizzazione",
    marketplace_report: 'Report del Marketplace',
    story_writing: 'Scrittura di storie',
    Ai_quiz: 'Quiz AI',
    generate_quiz: 'Genera quiz',
    create_story: 'Crea storia',
    change_layout_page: 'Stai per cambiare il layout della pagina.',
    change_layout_message:
      'Solo testo, immagini, sfondo e logo verranno mantenuti. Gli altri elementi verranno rimossi.',
    reviews: 'Recensioni',
    tab_attachments: 'Allegati',
    zoom_in: 'Ingrandisci',
    zoom_out: 'Rimpicciolisci',
    zoom_reset: 'Reimposta zoom',
    no_attachment: 'Nessun allegato.',
    select_upload_simulation: 'Seleziona/carica simulazione.',
    quiz_updated_successfully: 'Quiz aggiornato con successo!',
    quizes: 'Quiz',
    trivia: 'Curiosità',
    closing: 'Chiusura in corso...',
    products: 'Prodotti',
    ask_questions: 'Fai una domanda qui...',
    course_information: 'Informazioni sul corso',
    course_assistance: 'Assistenza alla creazione del corso',
    go_back: 'Torna indietro',
    ai_generate_content_progress: 'Generazione dei contenuti in corso',
    view_generate_content: 'Visualizza contenuti generati',
    generate_error: 'Errore di generazione!',
    confirm_creating_course:
      'Vuoi confermare la creazione del corso con questi contenuti?',
    generate_content_automatically:
      'Questo aggiungerà tutti i contenuti generati come lezioni e pagine al tuo corso automaticamente.',
    quiz_created_successfully: 'Quiz creato con successo!',
    create_quiz: 'Crea quiz',
    quiz_setting: 'Impostazioni del quiz',
    please_fill_quiz_setting:
      '* Compila tutti i campi delle impostazioni del quiz',
    question_list: 'Elenco delle domande',
    add_quiz_to_page: 'Aggiungi quiz alla pagina',
    form_create_question: 'Modulo per creare una domanda',
    user_information_updated: 'Informazioni utente aggiornate!',
    your_stripe_activete_to_continue:
      'Il tuo account Stripe è inattivo. Connettiti o attivalo per continuare.',
    connect_tripe: 'Connetti Stripe',
    certificate_sent_sucessfully:
      'Certificato inviato con successo alla tua email.',
    error_try_again: 'Errore. Riprova!',
    error_delete_channel: "Errore durante l'eliminazione del canale.",
    error_update_sub: "Errore nell'aggiornamento dell'abbonamento.",
    end_time_cannot_start: "L'ora di fine non può essere prima dell'inizio.",
    start_date_time_interval: 'Data e ora di inizio sono obbligatorie!',
    podcast_updated_successful: 'Podcast aggiornato con successo.',
    podcast_created_successful: 'Podcast creato con successo.',
    podcast_published_successful: 'Podcast pubblicato con successo',
    podcast_cover_updated: 'Copertina del podcast aggiornata',
    new_podcast_details:
      'Verrà creato un nuovo podcast con i dettagli inseriti.',
    current_update_podcast:
      "Aggiorna l'attuale podcast, musica e dettagli delle storie.",
    create_new_podcast: 'Crea un nuovo podcast',
    publish_podcast_public_view:
      'Pubblica il podcast per la visualizzazione pubblica.',
    only_allowed_twenty_five_email: 'Sono consentite solo 25 email',
    only_allowed_five_email: 'Sono consentite solo 5 email.',
    cover_is_required: 'La copertina è obbligatoria.',
    topic_is_required: "L'argomento è obbligatorio.",
    delete_schedule: 'Elimina programma',
    make_as_coaching: 'Segna come Disponibile per Coaching',
    manage_category: 'Gestisci categoria',
    threshold: 'Soglia',
    threshold_popup:
      'Valore soglia in percentuale (%), il valore dopo il quale viene attivata la raccomandazione per la categoria selezionata.',
    list_of_catagory: 'Elenco delle categorie',
    category_name: 'Nome della categoria',
    category_threshold: 'Soglia della categoria',
    play_game: 'Gioca',
    switching_organization: 'Cambio organizzazione in corso...',
    coaching_session: 'Sessione di coaching',
    required_channel_id: "L'ID del canale è obbligatorio!",
    error_occured_try_again: 'Si è verificato un errore. Riprova!',
    please_complete_marketplace_form: 'Completa il modulo del marketplace!',
    upload_file_corrupt: 'Il file caricato è danneggiato.',
    course_not_published: 'Il corso non è ancora stato pubblicato!',
    error_request: 'Errore nella richiesta. Riprova!',
    skill_request: 'Completa i campi mancanti!',
    error_occured: 'Si è verificato un errore. Riprova!',
    show_time: 'Orario',
    start_time: 'Ora di inizio',
    end_time: 'Ora di fine',
    room_name: 'Nome del Podcast',
    add_guest_speaker: 'Aggiungi ospite',
    cover_picture: 'Immagine di copertina',
    guest_speaker: 'Ospiti',
    see_more: 'Vedi di più',
    see_less: 'Vedi meno',
    background: 'Sfondo',
    icon: 'Icona',
    icon_size: "Dimensione dell'icona",
    icon_color: "Colore dell'icona",
    only_text: 'Solo testo',
    change_bg: 'Cambia colore di sfondo',
    bg_color: 'Colore di sfondo',
    font_size: 'Dimensione carattere',
    normal: 'Normale',
    change_color: 'Cambia colore del testo',
    slant_text: 'Testo inclinato',
    text_radius: 'Raggio del testo',
    vertical_align: 'Allineamento verticale',
    horizontal_align: 'Allineamento orizzontale',
    change_icon_color: "Cambia colore dell'icona",
    upload_icon: 'Carica icona',
    upload_signature: 'Carica firma',
    add_another_sign: "Aggiungi un'altra firma",
    name_badges: 'Nome del badge',
    should_less_150: 'deve essere di 150 caratteri o meno',
    your_badge: 'Il tuo badge',
    do_you_want_delete_badge: 'Sei sicuro di voler eliminare questo badge?',
    do_you_want_delete_cert:
      'Sei sicuro di voler eliminare questo certificato?',
    upload_logo: 'Carica logo',
    name_of_cert: 'Nome del certificato',
    upload_cert: 'Aggiorna certificato',
    your_cert: 'Il tuo certificato',
    translate_to: 'Traduci in',
    select_file_attach: 'Seleziona file da allegare',
    certificate: 'Certificato',
    badge: 'Badge',
    publish_options: 'Opzioni di pubblicazione',
    publish_skills_journey: 'Pubblica percorso competenze',
    videos: 'Video',
    generate_ai_video:
      "Il processo di generazione del video può richiedere tempo. Riceverai un'email una volta completato.",
    trainer_information: 'Informazioni del formatore',
    promotional_video_link: 'Link del video promozionale',
    please_select: 'Seleziona',
    image_name: 'Nome immagine:',
    image_size: 'Dimensione immagine:',
    charecters_fifteen_less: '15 caratteri o meno',
    leadership: 'Leadership',
    text_arc: 'Arco del testo',
    vertical: 'Verticale',
    horizontal: 'Orizzontale',
    badge_history: 'Cronologia badge',
    templates: 'Modelli',
    sign: 'Firma',
    logo: 'Logo',
    certificate_history: 'Cronologia certificati',
    please_wait: 'Attendere prego...',
    information: 'Informazioni',
    support_five_thousand_live_event:
      "Supporta fino a 5000 partecipanti per l'evento",
    support_ten_live_event: 'Supporta fino a 10 partecipanti video live',
    we_will_back_participant:
      "Torneremo con l'evento con accesso a un grande numero di partecipanti.",
    course_objectives: 'Obiettivi del corso',
    course_outlines: 'Programma del corso',
    price_dollor: 'Prezzo (USD)',
    not_completed: 'Non completato',
    enable_marketplace: 'Abilita Marketplace',
    enable_course_ai: 'Abilita creazione corsi con AI',
    enable_report_to_admin: "Abilita segnalazione all'amministratore",
    enable_white_label: 'Abilita White Label',
    enable_eleven_labs_for_maze_play: 'Abilita ElevenLabs per giocare ai Maze',
    enable_eleven_labs_for_maze_play_cloned:
      'Abilita ElevenLabs per voci clonate',
    simulation_quiz: 'Quiz di simulazione',
    bg_color_setting: 'Impostazione colore sfondo',
    color_preview: 'Anteprima colore',
    choose_new_color: 'Scegli un nuovo colore',
    remove_color: 'Rimuovi colore',
    apply_color: 'Applica colore',
    elemeent_in_a_sceenario_page:
      "Non puoi aggiungere più elementi in questa pagina di scenario. Prova un'altra pagina o rimuovi un elemento esistente.",
    no_data_found: 'Nessun dato trovato',
    references: 'Riferimenti',
    open_file: 'Apri file',
    showing_result: 'Mostrando risultato:',
    fiften_day_free_trail: 'Prova gratuita di 15 giorni',
    your_browser_does_not_support: "Il tuo browser non supporta l'audio.",
    podcast_desc: 'Descrizione podcast',
    input_podcast_desc: 'Inserisci la descrizione del podcast',
    podcast_obj: 'Obiettivo del podcast',
    input_podcast_obj: "Inserisci l'obiettivo del podcast",
    podcast_outline: 'Schema del podcast',
    input_podcast_outline: 'Inserisci lo schema del podcast',
    add_file: 'Aggiungi file',
    generate_podcast_audio: 'Genera audio del podcast',
    generate_uploaded_file_input_parameter:
      'Genera in base al contenuto del file caricato.',
    go_backe_generation_state: 'Torna allo stato di generazione contenuto',
    create_ai_powered_podcast: 'Crea un podcast con intelligenza artificiale',
    generate_voice_for_all_podcast: 'Genera voce per tutti gli episodi',
    create_podcast_episode: 'Crea episodio del podcast',
    voice_name: 'Nome della voce',
    input_custom_name: 'Inserisci un nome personalizzato!',
    enter_custom_name: 'Inserisci nome personalizzato per la voce',
    upload_complete: 'Caricamento completato',
    uploading_in_progress: 'Caricamento in corso...',
    podcast_stream_content: 'Contenuto in streaming del podcast',
    upload_podcast_cover: 'Carica la copertina del podcast!',
    enter_podcast_name: 'Inserisci il nome del podcast!',
    podcast_topic: 'Argomento del podcast',
    enter_podcast_topic: "Inserisci l'argomento del podcast!",
    enter_podcast_desc: 'Inserisci la descrizione del podcast!',
    number_of_speaker: 'Numero di speaker',
    select_the_number_of_speaker: 'Seleziona il numero di speaker!',
    number_of_episode: 'Numero di episodi',
    input_number_of_episode: 'Inserisci il numero di episodi!',
    podcast_length: 'Durata del podcast',
    select_the_podcast_length: 'Seleziona la durata del podcast!',
    short_podcast: 'Corto (5–10 minuti)',
    medium_podcast: 'Medio (15–18 minuti)',
    long_podcast: 'Lungo (18+ minuti)',
    name_of_host: "Nome dell'host",
    enter_host_name: "Inserisci il nome dell'host!",
    guest_name: 'Nome degli ospiti',
    enter_guest_name: 'Inserisci il nome degli ospiti!',
    choose_speaker_tone: 'Scegli il tono dello speaker',
    enter_speaker_tone: 'Seleziona il tono per il podcast!',
    informal: 'Informale',
    formal: 'Formale',
    serious: 'Serio',
    light_humor: 'Umorismo leggero',
    casual: 'Casuale',
    select_content_source: 'Seleziona la fonte dei contenuti',
    from_internet: 'Da Internet',
    upload_pdf_internet: 'Carica PDF o pagina di contenuti',
    note: 'Nota:',
    podcast_content_will_be_automatically_generated:
      'Il contenuto del podcast sarà generato automaticamente da fonti attendibili su Internet.',
    upload_or_select_file: 'Carica o seleziona un file!',
    podcast_eposode_title: "Titolo dell'episodio del podcast",
    enter_podcast_title: "Inserisci il titolo dell'episodio!",
    podcast_episode_des: "Descrizione dell'episodio del podcast",
    enter_podcast_episode_des: "Inserisci la descrizione dell'episodio!",
    voice: 'Voce',
    music: 'Musica',
    select_music: 'Seleziona musica',
    play_the_music: 'Riproduci musica',
    stop_the_music: 'Ferma la musica',
    context: 'Contesto',
    generate_audio_content_selected_voice:
      'Genera contenuto audio con la voce selezionata.',
    required_field_before_submitting:
      'Compila tutti i campi obbligatori prima di inviare.',
    regenerate_voice: 'Rigenera voce',
    generate_voice: 'Genera voce',
    your_browser_does_not_suppot: "Il tuo browser non supporta l'audio.",
    are_sure_leave_podcast:
      'Sei sicuro di voler lasciare la pagina del podcast?',
    broadcast_ongoing:
      'La trasmissione è in corso. Sei sicuro di voler lasciare la pagina?',
    brodcaster_unavailable: "L'host non è disponibile.",
    setting_calender_for_booking:
      'Impostazione del calendario per le prenotazioni',
    add_calender: 'Aggiungi calendario',
    waiting_join_host: "In attesa che l'host si unisca...",
    no_reviews_found: 'Nessuna recensione trovata',
    rated_already: 'Hai già valutato questa trasmissione live',
    downlink_png: 'Scarica come PNG',
    downlink_jpg: 'Scarica come JPG',
    donwload_file_format: 'Seleziona il formato del file da scaricare.',
    crashed_event:
      "L'evento è andato in crash. Crea un nuovo evento. Ci scusiamo per l'inconveniente.",
    prompt: 'Prompt:',
    generated_image: '🚀 Generazione immagine in corso... Attendere prego.',
    download_add: 'Scarica tutto',
    setting_generator: 'Impostazioni del generatore',
    enter_image_prompt: "Inserisci il prompt dell'immagine",
    image_prompt: "Prompt dell'immagine",
    negative_prompt: 'Contenuto indesiderato',
    negative_image_prompt: 'Prompt immagine indesiderato',
    number_output: 'Numero di immagini da generare',
    enter_number_output: 'Inserisci il numero',
    image_style: "Stile dell'immagine",
    output_format: 'Formato output',
    seeds: 'Seed',
    enter_seeds: 'Inserisci il seed',
    performance_mode: 'Modalità prestazioni',
    quality: 'Qualità',
    speed: 'Velocità',
    balanced: 'Bilanciato',
    guidance_scale: 'Scala guida',
    enter_guidance: 'Inserisci valore guida',
    select_image: "Seleziona un'immagine.",
    image_prmt: 'Prompt immagine',
    generate_image_list_empty: 'Nessuna immagine disponibile.',
    knowledge_center_tooltrip_des:
      "Ottieni risposte precise e pertinenti basate su fonti da Internet. L'AI utilizza contenuti dal web.",
    contexts: 'Contesti',
    ai_processing_video_sharebot:
      "L'elaborazione AI del video Sharebot è valida per 24 ore.",
    remove_sharebot_video:
      'Per rimuovere il video Sharebot, elimina la sezione audio/video.',
    remove_sharebot_video_audio:
      'La rimozione della sezione audio eliminerà il link Sharebot ma il contenuto rimarrà nella libreria.',
    monthly_live_stream:
      'Contatta il supporto per modificare il limite di live stream mensile.',
    monthly_transcribe_limit:
      'Contatta il supporto per modificare il limite mensile di trascrizione.',
    must_be_one_to_three_hundred: 'Il valore deve essere tra 1 e 300 minuti.',
    all_field_required: 'Tutti i campi sono obbligatori.',
    duration_minute: 'Durata (max 300 minuti)',
    gender: 'Genere',
    select_gender: 'Seleziona Genere',
    accent: 'Accento',
    select_accent: 'Seleziona Accento',
    create_voice: 'Crea Voce',
    enter_voice_name: 'Inserisci Nome Voce',
    select_voice_gender: 'Per favore seleziona il genere della voce',
    upload_voice: 'Carica la tua voce',
    upload_voice_mp_three: 'Carica la tua voce (.mp3)',
    cloned_voice: 'Voci Clonate',
    voice_type: 'Tipo di Voce',
    select_voice_type: 'Seleziona Tipo di Voce',
    sharelook_stand: 'Standard',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Personalizzata (Clonazione Voce)',
    create_auto_flow: 'Crea flusso automatico',
    how_many_layers: 'Quanti livelli',
    verify_selection: 'Verifica Selezione',
    uploaded_successful: 'Caricamento riuscito',
    upload_failed: 'Caricamento fallito',
    upload_only_five_mb: 'Carica contenuti (file PDF, max 5)',
    docs_from_org_library: "Usa Documento dalla Libreria dell'Organizzazione",
    failed_maze_generate:
      'Generazione del labirinto fallita. Per favore riprova.',
    generate_metamaze: 'Generazione MetaMaze in corso...',
    metamaze_being_generated:
      'Il tuo MetaMaze è in fase di generazione. Sarai avvisato via email quando il processo sarà completato.',
    metamaze_generate_successfully: 'MetaMaze generato con successo!',
    metamaze_with_proceed: 'Ora puoi procedere con il MetaMaze.',
    ai_metamaze_generate: 'Generazione AI MetaMaze',
    what_kind_maze_create: 'Che tipo di labirinto vuoi creare?',
    manual_metamaze_creation: 'Creazione manuale di MetaMaze',
    manually_maze_customizing_scnario:
      'Crea manualmente un labirinto personalizzando scenario e albero delle opzioni',
    maze_ai_generated: 'Generazione automatica del labirinto con AI',
    unmark_deadend: 'Rimuovi marcatura di vicolo cieco',
    mark_deadend: 'Marca come vicolo cieco',
    select_multiple_image_for_scenario:
      'Puoi selezionare più immagini per lo scenario.',
    select_your_image: 'Le immagini selezionate',
    click_to_preview: 'Clicca per anteprima',
    are_you_sure_delete_image: 'Sei sicuro di voler eliminare questa immagine?',
    select_image_from_library: 'Seleziona immagine dalla Libreria Media',
    uploading_video: 'Caricamento video in corso...',
    tree_node_type: "Tipo di Nodo dell'Albero",
    correct_option_scenario: 'Opzione o Scenario Corretto',
    incorrect_option: 'Opzione Errata',
    option_scenario_without_text: 'Opzione o Scenario senza testo',
    dead_end: 'Vicolo Cieco (Bordo Rosso)',
    correct_path: 'Percorso Corretto',
    incorrect_path_not_selected_correct_option_path:
      "Percorso Errato / Percorso in cui non è stata selezionata l'opzione corretta.",
    double_click_on_tree_node:
      "Quando fai doppio clic su un nodo dell'albero, l'editor di testo scorrerà automaticamente per mostrare il contenuto di quel nodo.",
    add_scenario: 'Aggiungi Scenario',
    add_option: 'Aggiungi Opzione',
    an_error_occured: 'Si è verificato un errore:',
    download_summary: 'Scarica Sommario',
    step_wise_analysis: 'Analisi passo-passo',
    step: 'Passo',
    upload_csv_file: 'Carica file CSV',
    download_template_to_import: 'Scarica modello di esempio per importare',
    please_input_email: 'Per favore inserisci email.',
    email_at_least_three_characters: "L'email deve avere almeno 3 caratteri.",
    email_cannot_be_empty: "L'email non può essere vuota.",
    input_email_in_new_line:
      'Per favore inserisci email (ogni email in una nuova riga)',
    role: 'Ruolo',
    select_role: 'Seleziona un ruolo',
    select_group: 'Seleziona un gruppo',
    identification_number: 'Numero di identificazione (Opzionale)',
    add_identification_number:
      'Per favore aggiungi un numero di identificazione',
    pie_chart_of_all_categories:
      'Grafico a torta di tutte le categorie basato sul loro utilizzo su Sharelook.',
    total_sharesphere_question_answered_by_users:
      "Totale domande ShareSphere risposte dagli utenti nell'organizzazione corrente, con queste categorie e i rispettivi risultati di successi e fallimenti.",
    voice_style_over_the_text: `Dove puoi usare molti stili di voce sul testo che digiti bla bla bla Lorem Ipsum è semplicemente un testo fittizio dell'industria della stampa e della composizione tipografica. Lorem Ipsum è stato il testo standard dell'industria sin dagli anni 1500.`,
    input_your_question: 'Per favore inserisci la tua domanda!',
    make_me_sales_manager: 'es: Cosa può farmi diventare un sales manager',
    enter_the_number_relevant_document:
      'Inserisci il numero di documenti rilevanti',
    please_wait_loading_result: 'Attendere il caricamento dei risultati...',
    no_result_found: 'Nessun risultato trovato, prova a fare più domande',
    browser_doesnot_support_iframes: 'Il tuo browser non supporta gli iframe',
    total_duration: 'Durata Totale',
    number_of_messages: 'Numero di Messaggi',
    search_result: 'Risultati della ricerca',
    count_result: '(1244 risultati)',
    your_other_interests: 'I tuoi altri interessi',
    your_total_score: 'Il tuo punteggio totale',
    add_a_question: '+ aggiungi una domanda',
    travia_question_empty: 'La lista delle domande trivia è vuota.',
    video_generation_is_on_queue: 'La generazione del tuo video è in coda!',
    checking_video_status: 'Controllo stato video...',
    total_quizzes: 'Quiz Totali',
    number_of_votes: 'Numero di Voti',
    total_events: 'Eventi Totali',
    number_of_rates: 'Numero di Valutazioni',
    number_of_likes: 'Numero di Mi Piace',
    all_courses: 'Tutti i Corsi',
    total_questions: 'Domande Totali',
    no_skill_journey: 'Nessun percorso di abilità disponibile!',
    search_no_results: '- nessun risultato disponibile!',
    no_image_generated: 'Nessuna immagine generata!',
    all_topic_in_this_lesson:
      'Tutti gli argomenti di questa lezione saranno eliminati. Questa operazione non può essere annullata.',
    content_has_been_generated:
      'Il contenuto è stato generato per questo argomento.',
    update_course_template: 'Aggiorna modello del corso',
    add_course_template: 'Aggiungi modello del corso',
    create_course_now: 'Crea corso ora',
    preview_course: 'Anteprima corso',
    layout: 'Layout',
    import_from_youtube: 'Importa da Youtube',
    my_media_library: 'La mia libreria media',
    bg_added: 'Sfondo aggiunto',
    add_bg: 'Aggiungi sfondo',
    booked_schedule: 'Programma prenotato',
    add_schedule: 'Aggiungi programma',
    are_you_delete_schedule: 'Sei sicuro di voler eliminare questo programma?',
    add_task: 'Aggiungi attività',
    update_calender: 'Aggiorna calendario',
    manage_cookies: 'Gestisci i cookie',
    cookie_banner_text:
      'Utilizziamo i cookie per migliorare la tua esperienza di navigazione, analizzare il traffico del sito e personalizzare i contenuti. La tua privacy è importante per noi.',
    accept_all_cookies: 'Accetta tutti i cookie',
    reject_all: 'Rifiuta tutto',
    customize: 'Personalizza',
    cookie_preferences_title:
      'Preferenze dei cookie e impostazioni sulla privacy',
    privacy_subtitle:
      'La tua privacy è importante per noi. Scegli quali cookie desideri accettare. Puoi modificare queste impostazioni in qualsiasi momento.',
    save_choices: 'Salva le scelte',
    strictly_necessary: 'Strettamente necessari',
    strictly_necessary_desc:
      'Questi cookie sono essenziali per il corretto funzionamento del sito web. Consentono funzioni di base come la navigazione nelle pagine, l’invio di moduli e l’accesso alle aree sicure. Senza di essi, il sito non può funzionare correttamente.',
    analytics_performance: 'Analisi e prestazioni',
    analytics_performance_desc:
      'Questi cookie ci aiutano a capire come i visitatori interagiscono con il sito, raccogliendo e riportando informazioni in forma anonima. Ci permettono di migliorare le prestazioni e l’esperienza utente.',
    advertising_marketing: 'Pubblicità e marketing',
    advertising_marketing_desc:
      'Questi cookie vengono utilizzati per rendere i messaggi pubblicitari più pertinenti per te. Evitano di mostrarti più volte lo stesso annuncio e garantiscono che gli annunci vengano visualizzati correttamente.',
    tracking_social: 'Tracciamento e social media',
    tracking_social_desc:
      'Questi cookie abilitano funzionalità avanzate e personalizzazioni, come funzioni di social media e contenuti personalizzati. Possono essere impostati da noi o da fornitori di terze parti.',
    functional: 'Funzionali',
    functional_desc:
      'Questi cookie consentono funzioni avanzate come il supporto in chat, l’assistenza in tempo reale e altre funzioni interattive che migliorano la tua esperienza sul sito.',
    your_rights: 'I tuoi diritti:',
    rights_description:
      'Puoi revocare il tuo consenso, accedere ai tuoi dati o richiederne la cancellazione in qualsiasi momento.',
    withdraw_consent: 'Revoca tutti i consensi',

    how_many_options: 'Quante opzioni',
    add_content: 'Aggiungi contenuto',
    downloads_center: 'Centro download',
    sharelook_help_center: 'Centro assistenza Sharelook',
    channel_outline: 'Schema del canale',
    channel_objectives: 'Obiettivi del canale',
    no_sop_available: 'Nessun elenco SOP disponibile.',
    generate_world_summary: 'Genera scenario',
    world_scenario: 'Scenario reale',
    drag_icon_hint:
      'Suggerimento: trascina l’icona sul canvas per posizionarla',
    drag_text_hint:
      'Suggerimento: trascina il testo sul canvas per posizionarlo',
    edit_badge: 'Modifica badge',
    create_new_badge: 'Crea nuovo badge',
    select_video_preview: 'Seleziona video per anteprima',
    certificate_title_required: 'Titolo del certificato obbligatorio',
    discard_changes: 'Annulla modifiche',
    edit_certificate: 'Modifica certificato',
    add_another_logo: 'Aggiungi un altro logo',
    optional: 'Opzionale',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Crea nuova missione',
    quest_filter_title: 'Missioni',
    sharelook_assistance: 'Coaching Sharelook',
    upload_scorm_zip: 'Carica file ZIP SCORM',
    only_letters_numbers_space_dot_allowed:
      'Sono consentite solo lettere, numeri, spazi e punti!',
    video_playing: 'In riproduzione',
    course_price_message: `*Questo corso sarà pubblicato solo per gli utenti dell'organizzazione e non può essere rivenduto sul marketplace.`,
    lesson_must_be_positive: 'Il numero di lezioni deve essere maggiore di 1',
    btn_proceed: 'Procedi',
    rule_select_music: 'Seleziona una musica',
    course_info: 'Informazioni sul corso',
    content_selection: 'Selezione dei contenuti',
    course_content_source: 'Origine dei contenuti del corso',
    choose_how_to_source: 'Scegli come ottenere i contenuti per questo corso:',
    automatic_selection: 'Selezione automatica',
    system_will_automatically_select_relavant_documents:
      'Il sistema selezionerà automaticamente i documenti rilevanti dalla tua libreria',
    manual_selection: 'Selezione manuale',
    choose_specific_documents_from_your_library:
      'Scegli documenti specifici dalla tua libreria',
    upload_files: 'Carica file',
    upload_new_documents:
      'Carica nuovi documenti (PDF, DOC, DOCX, PPT, PPTX, TXT) - massimo 5 file',
    file: 'File',
    ready_to_upload: 'Pronto per il caricamento',
    clear_all: 'Cancella tutto',
    confirm_course_wide_premiew: 'Conferma anteprima corso',
    generate_course_preview: 'Genera anteprima corso',
    instructions_across_the_course_to_generate:
      'Applicheremo le tue istruzioni a tutto il corso per generare un’anteprima. Rivedi tutto prima di confermare o annullare.',
    instruction_to_preview_course_wide:
      'Istruzioni per l’anteprima dell’intero corso:',
    edit_content: 'Modifica contenuto',
    manage_course_template: 'Gestisci modello del corso',
    undo: 'Annulla',
    apply_changes: 'Applica modifiche',
    characters: 'Caratteri',
    apply_all: 'Applica tutto',
    apply_to_all: 'Applica a tutti',
    use_this_content: 'Usa questo contenuto',
    original: 'Originale',
    edited: 'Modificato',
    edited_content_preview: 'Anteprima contenuto modificato',
    apply_edits_to_all_topices: 'Applicare le modifiche a tutti gli argomenti?',
    current_editing_instructions_across_the_whole_course:
      'Questo applicherà le istruzioni di modifica correnti a tutto il corso. Puoi rivedere l’anteprima combinata prima di salvare.',
    edit_content_instructions: 'Istruzioni per modificare il contenuto',
    generate_content_for_this_topic_instruction:
      'Genera contenuto per questo argomento utilizzando le tue istruzioni',
    descrip_edit_content:
      'Descrivi come modificare questo contenuto (es. riduci, semplifica, riscrivi)',
    try_short_clear_direcctives: `Prova con istruzioni brevi e chiare. Esempi: "Riduci a 100 parole mantenendo i punti chiave", "Semplifica il linguaggio", "Rendi più conciso e rimuovi il superfluo".`,
    we_preserve_the_core_meaning:
      'Manteniamo il significato principale mentre applichiamo le tue istruzioni.',
    feedback_optional: 'Feedback (opzionale)',
    write_your_feedback_here: 'Scrivi il tuo feedback qui',
    from_web: 'Dal web',
    from_desktop: 'Dal desktop',
    pleae_wait_processing: 'Attendi, elaborazione in corso...',
    create_simulation_from_screen_capture:
      'Crea simulazione da cattura schermo',
    sharelook_not_found: 'ShareLook non trovato',
    sharelook_screen_capture_application_not_be_opened:
      'L’applicazione di cattura schermo ShareLook non può essere aperta. Potrebbe non essere installata sul tuo computer.',
    download_sharelook: 'Scarica ShareLook',
    launch_sharelook_application: 'Avvia applicazione ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Questo aprirà l’applicazione ShareLook per la cattura dello schermo.',
    sharelook_dosenot_open:
      'Se ShareLook non si apre, potrebbe non essere installato sul tuo computer.',
    open_sharelook: 'Apri ShareLook',
    download_app: 'Scarica app',
    background_image_setting: 'Impostazioni immagine di sfondo',
    current_image: 'Immagine attuale',
    change_image: 'Cambia immagine',
    remove_image: 'Rimuovi immagine',
    no_background_image_selected: 'Nessuna immagine di sfondo selezionata',
    add_image: 'Aggiungi immagine',
    this_will_open_for_screen_recording:
      'Questo aprirà l’applicazione ShareLook per la registrazione dello schermo.',
    ai_image_generation: 'Generazione immagini AI',
    image_edit: 'Modifica immagine',
    text_to_image: 'Testo in immagine',
    output_gallary: 'Galleria risultati',
    instant_generation: 'Pronto per la generazione immediata',
    prompt_and_unleash_the_power: 'Inserisci un prompt e libera la sua potenza',
    use_this_image: 'Usa questa immagine',
    error_generating: 'Errore durante la generazione.',
    generation_tips: 'Suggerimenti di generazione',
    detailed_descriptions_for_more_accurate_results:
      'Usa descrizioni dettagliate per risultati più accurati',
    reference_image: 'Immagine di riferimento',
    select_pixel_image: 'Seleziona immagine pixel',
    max_mb: 'Massimo 50MB',
    please_enter_text_to_appear_image:
      'Inserisci il testo che apparirà sull’immagine',
    enter_text_to_apear_in_the_image:
      'Inserisci il testo da visualizzare sull’immagine',
    generate_image: 'Genera immagine',
    prompt_assistant: 'Assistente prompt',
    generate_image_using_suggested_prompt:
      'Genera immagine utilizzando il prompt suggerito',
    talk_to_ai_about_the_image_generate:
      'Parla con l’AI dell’immagine che vuoi generare',
    ask_for_prompt_suggestions: 'Chiedi suggerimenti per il prompt...',
    enter_a_search_term_to_find_stock_images:
      'Inserisci un termine di ricerca per trovare immagini stock',
    choose_your_content_source: 'Scegli la tua fonte di contenuto:',
    upload_new_document_from_your_device:
      'Carica nuovi documenti dal tuo dispositivo',
    automatic_library_selection: 'Selezione automatica libreria',
    system_automatically_selects_relevant_document:
      'Il sistema selezionerà automaticamente i documenti rilevanti',
    manual_library_selection: 'Selezione manuale libreria',
    generate_content: 'Genera contenuto',
    add_to_current_page: 'Aggiungi alla pagina corrente',
    generate_bullet_points: 'Genera punti elenco',
    generating: 'Generazione in corso',
    this_may_take_a_few_moments: 'Questo potrebbe richiedere qualche istante',
    apply_to_page: 'Applica alla pagina',
    scenario_escription: 'Descrizione dello scenario:',
    feedback: 'Feedback',
    form_mode: 'Modalità Modulo',
    chat_mode: 'Modalità Chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      "Questo genererà una continuazione della storia selezionata utilizzando l'IA.",
    continue_this_story_question: 'Continuare questa storia?',
    continue_this_story: 'Continua questa storia',
    what_will_happen: 'Cosa succederà:',
    the_ai_will_analyze_the_existing_story_content:
      "L'IA analizzerà il contenuto esistente della storia",
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Genera una continuazione naturale che segua lo stesso tono e stile',
    create_new_content_that_build_upon_the_current_narrative:
      'Crea nuovi contenuti che si basano sulla narrativa attuale',
    this_process_may_take_a_few_moments_to_complete:
      'Questo processo potrebbe richiedere qualche istante per completarsi.',
    no_existing_stories_found_for_this_course:
      'Nessuna storia esistente trovata per questo corso.',
    create_your_first_story: 'Crea la tua prima storia',
    existing_stories: 'Storie esistenti',
    create_new_story: 'Crea nuova storia',
    tone: 'Tono',
    style: 'Stile',
    genre: 'Genere',
    loading_your_stories: 'Caricamento delle tue storie...',
    edit_story: 'Modifica storia',
    story_preferences: 'Preferenze storia',
    please_input_your: 'Per favore inserisci il tuo',
    add_character_names_and_press_enter:
      'Aggiungi nomi dei personaggi e premi invio',
    select_or_type_your: 'Seleziona o digita il tuo',
    enter_your: 'Inserisci il tuo',
    position_of_the_story_in_the_lesson:
      'La posizione della storia nella lezione. La storia sarà aggiunta come blocco nella posizione specificata.',
    save_previous_content_on_the_pages:
      'Salva contenuto precedente nelle pagine',
    the_existing_content_in_the_selected_pages:
      'Il contenuto esistente nelle pagine selezionate sarà sostituito dalla storia generata.',
    real_world_scenario: 'Scenario del mondo reale',
    add_optional_instructions:
      'Aggiungi istruzioni opzionali (tono, lunghezza, pubblico, ecc.)',
    ready_to_enerate_your_real_world_scenario:
      'Pronto per generare il tuo scenario del mondo reale',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Clicca su "Genera Scenario del Mondo Reale" per creare uno scenario realistico basato sul contenuto della tua lezione.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      "L'IA analizzerà l'argomento e il contenuto della tua lezione",
    generate_a_practical_real_world_scenario:
      'Genera uno scenario pratico del mondo reale',
    you_can_then_edit_and_customize_the_result:
      'Puoi quindi modificare e personalizzare il risultato',
    add_it_as_a_new_page_to_your_lesson:
      'Aggiungilo come nuova pagina alla tua lezione',
    regenerate_with_instructions: 'Rigenera con istruzioni',
    add_real_world_scenario: 'Aggiungi Scenario del Mondo Reale',
    generate_real_world_scenario: 'Genera Scenario del Mondo Reale',
    simulation_has_been_stopped: 'La simulazione è stata interrotta!',
    loading_simulation: 'Caricamento simulazione...',
    you_have_exhausted_all_the_attempts: 'Hai esaurito tutti i tentativi',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Studia lo scenario su questa pagina e seleziona la risposta corretta dalle opzioni sottostanti.',
    attempts_limit_reached:
      'Limite dei tentativi raggiunto. Puoi giocare di nuovo ma il tuo punteggio non sarà salvato.',
    play_again: 'Gioca di nuovo',
    import_music_from_computer: 'Importa musica dal computer.',
    more: 'altro',
    no_badge_yet: 'Nessun badge ancora',
    competition_filter: 'Filtro competizione',
    global_leaderboard: 'Classifica globale',
    placeholder_for_the_global_leaderboard:
      'Questo è un segnaposto per la Classifica Globale.',
    badge_editor: 'Editor Badge',
    adjust_the_appearance_of_this_badge_icon:
      "Regola l'aspetto di questa icona del badge. Le modifiche si applicano solo a questo badge.",
    badge_style: 'Stile Badge',
    the_image_must_be_pixels: "L'immagine deve essere di 200x200 pixel.",
    badge_name: 'Nome Badge',
    badge_descrription: 'Descrizione Badge',
    enter_badge_criteria: 'Inserisci criteri del badge',
    discard: 'Annulla',
    badge_enable: 'Badge abilitati',
    award_users_with_badges_to_highlight_the_milestones:
      'Premia gli utenti con badge per evidenziare le tappe del loro percorso di apprendimento.',
    badge_types: 'Tipi di Badge',
    enable_or_disable_specific_badge_types_for_your_users:
      'Abilita o disabilita tipi di badge specifici per i tuoi utenti.',
    levels_enabled: 'Livelli abilitati',
    level_rules: 'Regole del livello',
    points: 'Punti',
    add_new_level: 'Aggiungi nuovo livello',
    add_level: 'Aggiungi livello',
    points_enabled: 'Punti abilitati',
    learning_activities_and_encourage_healthy_competition:
      'Premia gli utenti con punti per diverse attività di apprendimento e incoraggia una sana competizione.',
    award_points: 'Assegna punti',
    the_following_equates_the_value_of_one_item_completion:
      'Quanto segue equivale al valore del completamento di un elemento',
    general: 'Generale',
    others: 'Altro',
    certificate: 'Certificato',
    quiz_passed: 'Quiz superato',
    tip_approved: 'Suggerimento approvato',
    tip_liked: 'Suggerimento apprezzato',
    rewards: 'Ricompense',
    offer_discounts_when_learners_achieve:
      'Offri sconti quando gli studenti raggiungono un certo numero di punti, badge o livelli.',
    give_rewards: 'Dai ricompense',
    discount_course_purchases_by: 'Sconto sugli acquisti dei corsi del',
    with_points_more_than: 'con punti superiori a',
    with_badges_more_than: 'con badge superiori a',
    with_level_upwards_more_than: 'con livello superiore a',
    leaderboard: 'Classifica',
    leaderboard_enabled: 'Classifica abilitata',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Le classifiche offrono agli utenti una panoramica dei loro progressi in punti rispetto agli altri.',
    show_levels: 'Mostra livelli',
    show_points: 'Mostra punti',
    show_badges: 'Mostra badge',
    show_courses: 'Mostra corsi',
    show_certificates: 'Mostra certificati',
    leaderboard_settings: 'Impostazioni classifica',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Configura esperienze di classifica coinvolgenti per aumentare la motivazione degli studenti.',
    award_users_with_points_for_different_learning_activities:
      'Assegna punti agli utenti per diverse attività di apprendimento.',
    badge_set: 'Set di badge',
    choose_the_type_of_badges_your_users:
      "Scegli il tipo di badge che i tuoi utenti guadagneranno durante l'apprendimento.",
    levels: 'Livelli',
    Levels_represent_the_stages:
      'I livelli rappresentano le fasi del percorso di apprendimento di un utente.',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    quick_select: 'Selezione rapida',
    yesterday: 'Ieri',
    last_week: 'La scorsa settimana',
    Last_month: 'Il mese scorso',
    last_quarter: 'Lo scorso trimestre',
    historical_leaderboard: 'Classifica storica',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Monitora le tue prestazioni e vedi come ti posizioni tra i tuoi pari',
    time_period: 'Periodo di tempo',
    page_of: 'Pagina 1 di 1',
    edit_competition: 'Modifica competizione',
    create_competition: 'Crea competizione',
    arrow_right: 'freccia-destra',
    update_competition: 'Aggiorna competizione',
    competition_title: 'Titolo competizione',
    enter_competition_title: 'Inserisci il titolo della competizione',
    enter_competition_description:
      'Inserisci la descrizione della competizione',
    leaderboard_skill: 'Competenza',
    select_a_skill: 'Seleziona una competenza',
    no_skills_found: 'Nessuna competenza trovata',
    competition_period: 'Periodo della competizione',
    add_badge_rule: 'Aggiungi regola badge',
    create_badge: 'Crea badge',
    add_level_rule: 'Aggiungi regola livello',
    selected_participants: 'Partecipanti selezionati',
    no_participants: 'Nessun partecipante',
    start_end_date: 'Data inizio–fine',
    created_date: 'Creato da',
    new_competition: 'Nuova competizione',
    competitions_list: 'Elenco competizioni',
    search_competitions: 'Cerca competizioni...',
    are_you_sure_you_want_to_delete_the_competition:
      'Sei sicuro di voler eliminare la competizione?',
    history: 'Storico',
    export: 'Esporta',
    search_by_name: 'Cerca per nome...',
    no_historical_data_available_for_the_selected_period:
      'Nessun dato storico disponibile per il periodo selezionato.',
    no_leaderboard_data_available: 'Nessun dato della classifica disponibile.',
    competitions: 'Competizioni',
    leaderboards: 'Classifiche',
    welcome_back: 'Bentornato',
    track_your_performance_and_see:
      'Monitora le tue prestazioni e vedi come ti posizioni tra i tuoi pari',
    team_leaderboard: 'Classifica del team',
    try_again: 'Riprova',
    no_competitions_for_search: 'Nessuna competizione disponibile per',
    no_competitions_available: 'Nessuna competizione disponibile',
    no_competitions_matching_search:
      'Nessuna competizione trovata che corrisponda alla tua ricerca. Prova a modificare i termini di ricerca o controlla più tardi.',
    no_competitions_general:
      "Al momento non ci sono competizioni configurate. Controlla più tardi o contatta l'amministratore.",
    media_management: 'Gestione media',
    badgess_set: 'Set di badge',
    choose_the_default_visual_style_for_badge:
      'Scegli lo stile visivo predefinito per le icone dei badge utilizzate sulla piattaforma.',
    enable_badges: 'Abilita badge',
    add_badge: 'Aggiungi badge',
    min: 'Min',
    max: 'Max',
    your_rank: 'Il tuo punteggio',
    your_points: 'I tuoi punti',
    your_level: 'Il tuo livello',
    rank: 'Classifica #',
    level: 'Livello',
    progress: 'Progresso',
    new_folder: 'Nuova cartella',
    file_upload: 'Caricamento file',
    writer: 'Autore',
    text_documents: 'Documenti di testo',
    spreadsheets: 'Fogli di calcolo',
    impress: 'Impress',
    presentations: 'Presentazioni',
    capture_desktop_screen: 'Cattura schermo desktop',
    capture_desktop_screens: 'Cattura schermi desktop',
    your_documents: 'I tuoi documenti',
    manage_your_videos_images_audio_files:
      'Gestisci i tuoi video, immagini, file audio e altri asset utilizzati nella creazione dei contenuti.',
    your_organization_documents: 'Documenti della tua organizzazione',
    keep_your_organization_creative_assets_organized:
      'Mantieni gli asset creativi della tua organizzazione organizzati e accessibili—snellisci il lavoro di squadra e la produzione di contenuti.',
    your_public_documents: 'I tuoi documenti pubblici',
    curated_collection_of_media_assets_available:
      'Una raccolta curata di asset media disponibile per tutti—esplora, riutilizza e crea.',
    your_download_center_documents: 'Documenti del tuo centro download',
    repository_of_approved_media_assets_for_download:
      "Un repository di asset media approvati per il download e l'uso nei tuoi progetti.",
    search_files_and_folders: 'Cerca file e cartelle...',
    home: 'Home',
    folders: 'Cartelle',
    folder_name: 'Nome cartella',
    owner: 'Proprietario',
    last_updated: 'Ultimo aggiornamento',
    action: 'Azione',
    no_folders_found: 'Nessuna cartella trovata',
    files: 'File',
    enabling_ai: 'Abilitazione AI...',
    rename: 'Rinomina',
    copy: 'Copia',
    move: 'Sposta',
    verson_history: 'Cronologia versioni',
    manage_permission: 'Gestisci permessi',
    generate_audit_report: 'Genera rapporto di audit',
    last_edited: 'Ultima modifica',
    no_files_found: 'Nessun file trovato',
    are_you_sure_you_want_to_make_this_item_public:
      'Sei sicuro di voler rendere pubblico questo elemento? Verrà copiato nella tua libreria pubblica.',
    move_to_organization: "Sposta nell'organizzazione",
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Sei sicuro di voler copiare questo elemento nella libreria della tua organizzazione?',
    are_you_sure_you_want_to_make_this_item_private:
      'Sei sicuro di voler rendere privato questo elemento? Verrà copiato nella tua libreria personale.',
    date_modified: 'Data di modifica',
    workflow_management: 'Gestione workflow',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configura editor, approvatori e visualizzatori per questo documento.',
    error_Loading_editor: 'Errore caricamento editor',
    debug_info: 'Informazioni debug',
    loading_editor: 'Caricamento editor...',
    submitted_for_review: 'Inviato per revisione',
    editors: 'Editor',
    no_editors_added_yet:
      'Nessun editor aggiunto. Clicca "Aggiungi editor" per aggiungerne uno.',
    add_editor: 'Aggiungi editor',
    approvers: 'Approvatori',
    no_approvers_added_yet:
      'Nessun approvatore aggiunto. Clicca "Aggiungi approvatore" per aggiungerne uno.',
    add_approvers: 'Aggiungi approvatori',
    viewer: 'Visualizzatore',
    no_viewers_added_yet:
      'Nessun visualizzatore aggiunto. Clicca "Aggiungi visualizzatore" per aggiungerne uno.',
    add_viewer: 'Aggiungi visualizzatore',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Sei sicuro di voler eliminare gli elementi selezionati?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Panoramica Categoria',
    triviaReport: 'Categoria ShareSphere',
    overviewGraph: 'Grafico Panoramica Categoria',
    category: 'Categoria',
    phCategory: 'Seleziona Categoria',
    podcast: 'Podcast, Musica e Storie',
    pastPodcast: 'Podcast Passati',
    upcomingPodcast: 'Podcast Futuri',
    podcastLanguageTitle: 'Lingua di podcast, musica e storie',
    podcastLanguageCheckbox: 'Genera lingua AI per il mio podcast',
    howRate: 'Come valuti questo podcast?',
    podcastSubmit: 'Invia',
    podcastGuest: 'Ospite:',
    podcastReview: 'Recensioni',
    podcastEpishode: 'Episodi',
    podcastEnd: 'Il podcast è terminato',
    date_podcast: 'Data Podcast',
    skill_not_found: 'Spiacente! Nessun percorso di competenza trovato.',
    coaching: 'Coaching',
    webinar: 'Webinar',
    public_conference: 'Conferenza Pubblica',
    skill_journey_subtitle:
      'Aggiungi impostazioni al tuo percorso di competenza e seleziona chi può visualizzare e interagire con esso.',
    enable_white_label: 'Abilita white label',
    create_new_event_org: 'Crea un nuovo evento per la tua organizzazione.',
    create_new_event_marketplace: 'Crea un nuovo evento per il marketplace.',
    create_new_event_both:
      'Crea un nuovo evento sia per la tua organizzazione che per il marketplace.',
    event_outline: "Inserisci la descrizione dell'evento",
    event_obj: "Inserisci gli obiettivi dell'evento",
    event_description: "Inserisci la descrizione dell'evento",
    create_new_metamaze_org:
      'Crea un nuovo MetaMaze per la tua organizzazione.',
    create_new_metamaze_marketplace:
      'Crea un nuovo MetaMaze per il marketplace.',
    create_new_metamaze_both:
      'Crea un nuovo MetaMaze sia per la tua organizzazione che per il marketplace.',
    add_key_words: 'Aggiungi parole chiave',
    press_enter_make_keyword: 'Premi Invio per creare una parola chiave',
    disable_skip_quiz: 'Disabilita salta quiz',
    warning_complete_quiz: 'Per favore completa il quiz per procedere.',
    signup_email_verification:
      "Abbiamo inviato un link di verifica all'indirizzo email fornito. Visita quel link per confermare la registrazione.",
    verifying_registration: 'Verifica della registrazione in corso...',
    reset_password_linK:
      "Abbiamo inviato un link all'indirizzo email fornito. Visita quel link per impostare una nuova password.",
    reset_email_error:
      'Utente non trovato con questa email, per favore prova con il nome utente!',
    first_name: 'Nome',
    last_name: 'Cognome',
    error_firstName: 'Per favore inserisci il tuo nome',
    error_sharebot_organization: 'Per favore inserisci la tua organizzazione',
    error_lastName: 'Per favore inserisci il tuo cognome',
    private_conference: 'Conferenza Privata',
    public_conference: 'Conferenza Pubblica',
    discussion_room: 'Sala Discussioni',
    training_no_courses: 'Al momento non sei iscritto a nessun corso.',
    training_no_events: 'Al momento non sei iscritto a nessun evento.',
    allow_sharing_trainer_info:
      "Consenti la condivisione dell'indirizzo email nel marketplace",
    error_username_space: 'Il nome utente non può contenere spazi.',
    error_sharebot_organization_space:
      "Il nome dell'organizzazione non può contenere spazi.",
    edit_permission: 'Permesso di modifica',
    valid_price: 'Il prezzo deve essere maggiore di 0',
    course_price_message: `*il corso sarà pubblicato solo al numero di utenti acquistati dall'organizzazione e non potrà essere rivenduto nel marketplace`,
    valid_edit_price:
      'Il prezzo di modifica deve essere inferiore al prezzo di acquisto.',
    my_calendar: 'Il mio Calendario',
    error_valid_firstName: 'Per favore inserisci un nome valido.',
    error_valid_organization:
      'Per favore inserisci un nome organizzazione valido.',
    error_valid_lastName: 'Per favore inserisci un cognome valido.',
    error_name_spaces: 'Il nome non può contenere spazi',
    items: 'Elementi',
    publish_to_channel: 'Pubblica nella mia raccolta Canali',
    create_a_channel: 'Crea Canale',
    create_a_trivia: 'Crea Gioco Trivia',
    create_a_new_channel: 'Crea un Nuovo Canale',
    add_videos: 'Aggiungi Video',
    save_and_continue: 'Salva & Continua',
    channel: 'Canale',
    channels: 'Canali',
    view_channel: 'Visualizza Canale',
    edit_channel: 'Modifica Canale',
    delete_channel: 'Elimina Canale',
    my_video_channels: 'I miei Canali Video',
    training_no_channel: 'Al momento non sei iscritto a nessun canale.',
    monthly_price_required: 'Prezzo mensile richiesto',
    yearly_price_required: 'Prezzo annuale richiesto',
    one_time_price_required: 'Prezzo una tantum richiesto',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAR',
    report_coaching: 'COACHING',
    report_channel: 'CANALI',
    report_public_conference: 'CONFERENZA PUBBLICA',
    report_maze: 'LABIRINTO',
    channel: 'Canale',
    edit_price: 'Modifica Prezzo ($)',
    quantity: 'Quantità',
    payment_type: 'Tipo di pagamento',
    total_amount: 'Importo Totale ($)',
    net_amount: 'Importo Netto ($)',
    edit_option: 'Opzione Modifica',
    marketplace_price: 'Prezzo ($)',
    market_name: 'Nome',
    duration_min: 'Durata (Min)',
    users_total: 'Utenti (Totale)',
    sales_total: 'Vendite Totali (USD)',
    search_coaching: 'Cerca Coaching',
    search_channel: 'Cerca Canale',
    search_webinar: 'Cerca Webinar',
    search_maze: 'Cerca Labirinto',
    search_public_conference: 'Cerca Conferenza Pubblica',
    buyer_type: 'Tipo di acquirente',
    quanity: 'Quantità',
    channel_unit_amount: 'Importo Netto ($)',
    channel_updated_at: 'Data Aggiornamento',
    month_price: 'Prezzo (Mese)',
    year_price: 'Prezzo (Anno)',
    one_time_price: 'Prezzo (Una Tantum)',
    sharebot_organization: 'Aggiungi nuovo nome organizzazione',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Titolo del corso',
    ai_input_course_title: 'Inserisci il titolo del corso!',
    learning_objective_label: 'Obiettivo di apprendimento',
    learning_objective_message: "Inserisci l'obiettivo di apprendimento!",
    standard_question: 'Esiste uno standard che lo studente deve soddisfare?',
    standard_details_label: 'Dettagli dello standard',
    standard_details_message: 'Inserisci i dettagli dello standard!',
    estimated_duration_label: 'Durata stimata del corso (in minuti)',
    estimated_duration_message: 'Inserisci la durata stimata!',
    min_duration_message: 'La durata minima è di 5 minuti.',
    ai_mins: '25 minuti',
    industry_specific_question: 'È specifico per un settore particolare?',
    industry_label: 'Specifica il settore',
    industry_message: 'Inserisci il settore!',
    ai_course_creation: 'Creazione del corso con AI',
    course_generated: 'Corso generato da Sharelook',
    ai: 'AI',
    ai_you: 'Tu',
    ai_prompt_ready:
      'La tua richiesta è pronta. Ora puoi creare il contenuto del corso.',
    ai_unable_respond:
      "Spiacente! L'AI non è riuscita a rispondere alla tua richiesta. Per favore riprova.",
    ai_hide_toc: 'Nascondi sommario',
    ai_preview_toc: 'Anteprima sommario',
    ai_generate_toc_now: 'Genera sommario ora',
    ai_creation_course_title: 'Titolo del corso:',
    ai_creation_industry_specific: 'È specifico per un settore particolare:',
    ai_creation_industry: 'Settore:',
    ai_creation_standard_needed:
      'Esiste uno standard che lo studente deve soddisfare?',
    ai_creation_standard_details: 'Dettagli dello standard:',
    ai_creation_estimated_duration: 'Durata stimata del corso (in minuti):',
    minutes: 'minuti',
    ai_creation_learning_objective: 'Obiettivo di apprendimento:',
    setup_again: 'Configura di nuovo',
    ai_creation_confirm_title: 'Sei sicuro di voler resettare il modulo?',
    ai_creation_confirm_content:
      'Tutta la conversazione e i contenuti generati saranno resettati.',
    ai_toc: 'Sommario',
    ai_note_topic:
      'Nota: puoi riordinare gli argomenti del corso trascinandoli.',
    ai_add_topic: '+ Aggiungi argomento',
    add_topic: 'Aggiungi argomento',
    add_lesson: 'Aggiungi lezione',
    add_new_lesson: 'Aggiungi nuova lezione',
    ai_add_lesson: '+ Aggiungi lezione',
    attention: 'Attenzione',
    before_varifying: 'Prima della verifica',
    ai_save_later: 'Salva per dopo',
    ai_download_word_doc: 'Scarica come documento Word',
    ai_download_course_word_doc: 'Scarica il corso come documento Word',
    ai_create_course_button: 'Crea corso',
    ai_generate_course_content: 'Genera contenuto del corso',
    ai_out_of: 'su',
    ai_subtopic_failed_content:
      "Generazione del contenuto per i sottotemi fallita. Per favore clicca di nuovo su 'Genera contenuto del corso' solo per questi sottotemi.",
    ai_edit_topic: 'Modifica argomento',
    ai_edit_lesson_title: 'Modifica titolo della lezione',
    ai_save_topic: 'Salva argomento',
    ai_save: 'Salva',
    ai_save_lesson_title: 'Salva titolo della lezione',
    ai_add_new_topic: 'Aggiungi nuovo argomento',
    ai_download_ref: 'Scarica con riferimenti',
    ai_download_ref_content:
      'Scaricherà il corso come documento Word con i riferimenti.',
    ai_download_without_ref: 'Scarica senza riferimenti',
    ai_download_two_word: 'Verranno scaricati due documenti Word:',
    ai_download_two_word_content_one:
      '- uno con contenuto principale senza riferimenti,',
    ai_download_two_word_content_two:
      "e un altro con solo l'elenco dei riferimenti senza contenuti collegati.",
    ai_manage_content: 'Gestisci contenuti',
    ai_add_content_from_internet: '+ Aggiungi contenuti da internet',
    ai_confirm_start: 'Conferma di iniziare',
    ai_Verify: 'Verifica',
    ai_undo_warning:
      'Questa operazione può richiedere del tempo. Per favore non chiudere la finestra fino al completamento, poiché non può essere annullata.',
    ai_verified_content:
      "Hai verificato i contenuti. Dopo la verifica non potrai tornare alla conversazione con l'assistente AI su questi contenuti.",
    ai_want_proceed: 'Sei sicuro di voler procedere?',
    upload_simulation: 'Carica simulazione',
    name_simulation: 'Nome simulazione',
    selected_simulation_files: 'File simulazione selezionati',
    score_between_one_hundred: 'Il punteggio deve essere tra 1 e 100.',
    are_sure_simulation:
      'Sei sicuro di voler rimuovere questo file simulazione?',
    required_simulation: 'Punteggio richiesto',
    required_section_file: 'File sezione richiesto',
    simulation: 'Simulazione',
    simulation_quiz_games: 'Devi aggiungere quiz per il gioco',
    simulation_alert_des:
      'I giochi possono essere aggiunti solo se tutte le domande sono a scelta singola o multipla.',
    alert_info: 'Informazione',
    ai_number_quiz: 'Numero di quiz',
    ai_point: 'Punto',
    ai_points: 'Punti',
    val_required: 'Obbligatorio',
    games: 'Giochi',
    add_simulation: 'Aggiungi simulazione',
    text_tiewer: 'Visualizzatore testo',
    back_to_account: "Torna all'account",
    delete_account: 'Elimina account',
    delete_account_title: 'Elimina account ???',
    delete_account_subtitle: 'Qui puoi eliminare il tuo account.',
    delete_account_cannot_undo:
      'Stai per eliminare il tuo account. Questa azione non può essere annullata.',
    account_org_profile:
      "Tutti i corsi creati da te, il profilo dell'organizzazione e tutte le tue impostazioni saranno persi.",
    deleting_account_database:
      "L'eliminazione dell'account cancellerà tutti i tuoi dati dal nostro database.",
    account_confirm_delete: 'Sei sicuro di voler eliminare il tuo account?',
    action_cannot_be_undone: 'Questa azione non può essere annullata.',
    account_delete_message_success:
      'Il tuo account è stato eliminato con successo.',
    message_edit: 'Modifica',
    message_delete: 'Elimina',
    message_reply: 'Rispondi',
    attached_file: 'File allegato',
    attach_file: 'Allega file',
    attach_des: '25MB, dimensione massima file',
    view: 'Visualizza',
    go_to_marketplace: 'Vai al marketplace',
    learning_center: 'Centro di apprendimento',
    knowledge_center: 'Centro conoscenze',
    sharebot: 'Sharebot',
    sharebot_help_message: 'Come posso aiutarti oggi?',
    my_organization: 'La mia organizzazione',
    world_knowledge: 'Conoscenza mondiale',
    welcome_to_sharelook: 'Benvenuto in Sharelook!',
    sharelook_you_want_go: 'Dove vuoi andare oggi?',
    shareLook_learning_management_system:
      "Vai al sistema di gestione dell'apprendimento ShareLook, dove puoi creare o accedere a risorse di formazione come eventi live e corsi per la tua organizzazione in ShareLook.",
    shareLook_powerful_ai_system:
      'Vai al potente sistema AI di ShareLook, dove puoi caricare file PDF e ottenere risposte utili in pochi secondi. Ottieni risposte rapide da risorse caricate nella tua organizzazione o dalla nostra categoria di conoscenza globale.',
    edit_now: 'Modifica ora',
    sharelook_log_out:
      "Hai effettuato il logout da Sharelook. Effettua nuovamente l'accesso!",
    sorry_error: 'Spiacente! Abbiamo riscontrato un errore.',
    login: 'Accesso',
    refresh_page: 'Aggiorna pagina',
    just_a_moment: 'Un momento per favore',
    enter_lname_fname: 'Inserisci nome e cognome per continuare.',
    procced_to_sharelook: 'Vai a Sharelook',
    option_one: 'Opzione 1',
    option_two: 'Opzione 2',
    selected_image: 'Immagine selezionata:',
    add_text: 'Aggiungi testo',
    linkdin_is_required: 'LinkedIn è obbligatorio.',
    bio_is_required: 'Biografia obbligatoria.',
    save_user_information: 'Salva informazioni utente',
    select_all: 'Seleziona tutto',
    enable_ai: 'Abilita AI',
    load_more: 'Carica altro',
    channel_id: 'ID canale.',
    send: 'Invia',
    v4: 'Informazioni',
    subscription: 'Abbonamento',
    reset_user_flag: 'Resetta flag utente',
    delete_my_accont: 'Elimina il mio account',
    sharebot_sub_error: "Errore nell'abbonamento. Riprova!",
    sharebot_no_sub: 'Non hai un abbonamento attivo al momento.',
    sharebot_dont_sub: 'Non hai abbonamenti precedenti.',
    sharebot_prev_sub: 'Abbonamenti precedenti',
    sharebot_sub: 'Abbonamento ShareBot',
    sharebot_un_sub: 'Annulla abbonamento ShareBot',
    sharebot_no_available: 'Nessun dettaglio disponibile',
    sharebot_start_date: 'Data inizio:',
    sharebot_end_date: 'Data fine:',
    sharebot_sure: 'Sei sicuro?',
    sharebot_do_you_want: 'Vuoi',
    unsubscribe: 'Annulla abbonamento',
    unsubscribe_what: "Annullare l'abbonamento?",
    subscribe: 'Abbonati',
    subscribe_what: 'Abbonarsi?',
    subscribe_now: 'Abbonati ora',
    confirm: 'Conferma',
    sharebot_intel_knowledge_center: 'Centro conoscenze intelligente ShareBot',
    sharebot_welcome_paragraph:
      'Benvenuto nel Centro conoscenze ShareBot, chatbot AI progettato per rivoluzionare il modo in cui i professionisti accedono e collaborano alle informazioni.',
    expired: 'Scaduto',
    active: 'Attivo',
    Inactive: 'Inattivo',
    yearly_subscription: 'Abbonamento annuale',
    monthly_subscription: 'Abbonamento mensile',
    no_sharebot_org: 'Non hai un’organizzazione Sharebot',
    sharebot_start_free_trial: 'Inizia la prova gratuita',
    sub_month: 'Abbonamento mensile',
    sub_year: 'Abbonamento annuale',
    question_per_month: 'Archiviazione dati (1TB) e 1000 domande al mese',
    sharebot_para:
      'Procedendo, confermi leliminazione immediata dell organizzazione. Questa azione comporterà la perdita di tutti i preziosi approfondimenti forniti da ShareBot e non potrà essere annullata.',
    cancelled_date: 'Data di cancellazione:',
    live_straming_para:
      'Se desideri modificare il limite mensile di live streaming, contatta',
    sharelook_agree: 'Accetto i',
    terms_condition: 'termini e condizioni',
    and: 'e',
    privacy_policy: 'politica sulla privacy',
    save_for_later: 'Salva per dopo',
    ai: 'AI',
    no_video_yet: 'Nessun video selezionato ancora!',
    are_you_sure_delete_video: 'Sei sicuro di voler eliminare questo video?',
    video_des: 'Descrizione',
    video_now: 'Adesso',
    video_playing: 'In riproduzione:',
    video_no: 'Video n.',
    ai_generated_course: 'Corso generato da AI',
    create_course_on_our_own: 'Crea un corso da solo',
    ai_Assisted_ourse_reation: 'Creazione di corsi assistita da AI',
    pending: 'In attesa',
    published: 'Pubblicato',
    intro_course: 'nel tuo corso?',
    clone_course: 'Vuoi clonare',
    browser_audio_not_support: 'Il tuo browser non supporta il tag audio.',
    audio_popup_content:
      'Puoi utilizzare molti stili vocali sul testo che digiti bla Bla bla Lorem Ipsum è semplicemente un testo fittizio dell’industria della stampa e della composizione. Lorem Ipsum è lo standard dell’industria dal 1500,',
    close: 'Chiudi',
    podcast_rec: 'REG',
    create_podcast: 'Crea podcast',
    add_admin: 'AGGIUNGI ADMIN',
    delete_all: 'Elimina tutto',
    ai_podcast_audio: 'Audio AI del podcast',
    language: 'Lingua',
    podcast_download_content:
      '*Scarica il file audio AI per modificarlo e renderlo il tuo file audio.',
    upload_audio: 'Carica audio',
    browser_do_not_support_audio:
      'Il tuo browser non supporta l’elemento audio.',
    upload_cover: 'Carica copertina',
    upload_ai_creator: 'Creatore AI',
    required_cover_image: 'Immagine di copertina obbligatoria!',
    room_required_name: 'Nome del podcast obbligatorio!',
    add_guest_list: 'Per favore aggiungi la lista degli ospiti!',
    podcast_add_participants: 'AGGIUNGI PARTECIPANTE',
    topic_required: 'È richiesto almeno un argomento',
    podcast_description: 'DESCRIZIONE',
    podcast_date: 'DATA',
    date: 'Data',
    podcast_time: 'ora',
    podcast_to: 'a',
    podcast_all_day: 'Tutto il giorno',
    podcast_start_date_time: 'Data e ora di inizio richieste!',
    podcast_id: 'ID',
    selected_user: 'Invita utenti selezionati',
    see_more: 'Vedi di più',
    see_less: 'Vedi meno',
    no_review_yet: 'Nessuna recensione ancora, sii il primo a recensire.',
    request_to_speak: 'Accettare la richiesta di parlare dell’utente?',
    kick_user: 'Vuoi espellere questo utente?',
    accept_request: 'Accetta richiesta',
    kick: 'ESPULSO',
    started: 'INIZIATO',
    end: 'FINE',
    join_now: 'Partecipa ora',
    podcast_end: 'Il podcast è terminato',
    connecting: 'connessione in corso...',
    knowledge_center_know_today: 'Cosa vuoi sapere oggi?',
    knowledge_center_question: 'Per favore inserisci prima una domanda',
    knowledge_center_error: 'Spiacente! Si è verificato un errore.',
    knowledge_center_tooltrip:
      'Ottieni risposte rapide dalle risorse di apprendimento nel repository della tua organizzazione su ShareLook, con riferimenti adeguati e possibilità di anteprima e download dei documenti PDF referenziati.',
    my_organization: 'La mia organizzazione',
    world_knowledge: 'Conoscenza mondiale',
    open_file: 'Apri file',
    reference: 'Riferimento',
    are_you_cancel: 'Sei sicuro di voler annullare?',
    are_you_remove_media:
      'Sei sicuro di voler rimuovere il contenuto multimediale?',
    terms_agree: 'Accetto questi',
    ready: 'Pronto',
    send_email: 'INVIA EMAIL',
    active_users: 'Utenti attivi',
    sign_up_user: 'Utenti registrati',
    non_sign_up_user: 'Utenti non registrati',
    organisation: 'Organizzazione',
    usage_report: 'Rapporto di utilizzo',
    check_email: 'controlla la tua email',
    delete_schedule: 'Elimina programma',
    are_you_sure_delete_schedule:
      'Sei sicuro di voler eliminare questo programma?',
    add_task: 'Per favore inserisci un’attività!',
    coaching_available: 'Segna come disponibilità di coaching',
    message_booking_coaching:
      'Questa fascia oraria è stata prenotata da un utente per il coaching.',
    task_day: 'Giorno dell’attività',
    created_task_day: 'Hai creato un’attività per questo giorno.',
    event_day: 'Giorno dell’evento',
    has_booked_coaching: 'Un coaching è stato prenotato per questo giorno.',
    active_day: 'Giorno attivo',
    selectable_time_slots:
      'Le fasce orarie selezionabili a destra sono attive per questo giorno.',
    compare_last_month: 'Rispetto al mese scorso',
    uploading_file: 'Caricamento del file in corso',
    attach_file_course: 'allegato a questo corso.',
    fetch_request: 'Recupero della richiesta',
    finilize_upload: 'Finalizzazione del caricamento',
    scorm_scanned:
      'Attendere... Il tuo file SCORM caricato è in fase di scansione.',
    scan_status: 'Stato della scansione:',
    scan_completed: 'Scansione completata. Il tuo file è',
    scan_progress: 'Scansione in corso...',
    check_scorm: 'Controllo del formato del file SCORM... Attendere...',
    file_check_success: 'Verifica file riuscita',
    file_check_progress: 'Verifica del file in corso...',
    scorm_not_upload:
      'Il file caricato non è conforme allo standard SCORM 1.2. Caricare di nuovo il file.',
    select_question: 'Opzioni di risposta (seleziona una risposta corretta)',
    select_answer: 'Per favore seleziona un’opzione di risposta!',
    check_option_one: 'Per favore inserisci l’opzione uno!',
    check_option_two: 'Per favore inserisci l’opzione due!',
    check_option_three: 'Per favore inserisci l’opzione tre!',
    check_option_four: 'Per favore inserisci l’opzione quattro!',
    question_image: 'Immagine della domanda',
    select_question_image: 'Per favore seleziona un’immagine per la domanda!',
    ans_image: 'Immagine della risposta',
    upload_image_question: 'Carica immagine della risposta',
    select_image_answer: 'Per favore seleziona un’immagine di risposta!',
    save_question: 'Salva domanda',
    do_you_leave: 'Sei sicuro di voler uscire?',
    loose_all_progress: 'Perderai tutti i tuoi progressi.',
    welcome: 'Benvenuto',
    team_knowledge_quest: 'Missione di conoscenza del team',
    your_score: 'Il tuo punteggio',
    start_playing: 'Inizia a giocare',
    share_sphere_complete: 'ShareSphere completato',
    final_score: 'Punteggio finale',
    play_next: 'Gioca il prossimo',
    you_donot_access_event: 'Non hai accesso a questo evento.',
    ai_content_generated: 'Il contenuto è stato generato per questo argomento.',
    ai_popup_confirm_content: 'Conferma generazione contenuto',
    limit_transcribe_text:
      'Minuti rimanenti per la trascrizione: <0>{{ transcribe_limit }}</0> minuti <1/><2/> <3>. Per modificare il limite di trascrizione, contatta </3> <4>admin@sharelook.com</4>.',
    monthly_ai_credit_limit: 'Per modificare il limite di crediti IA, contatta',
    remaining_credits_text: 'Crediti IA rimanenti: <0>{{ remaining_credits }}</0> crediti <1/><2/> <3>. Per modificare il limite di crediti IA, contatta </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Non hai accesso a questo evento.',
    ai_course_title_training: 'Corsi di formazione sulla leadership',
    ai_course_object: 'Navigare nella leadership digitale',
    create_ai_video: 'Crea video AI',
    generate: 'GENERARE',
    video_generate_process:
      'Il processo di generazione del video potrebbe richiedere del tempo. Riceverai una email una volta completato.',
    stripe_account_connect:
      'Il tuo account Stripe è inattivo. Per favore collegalo o attivalo per continuare.',
    ai_creator: 'Creatore AI',
    check_video_status: 'Controllo dello stato di generazione del video...',
    video_on_queue: 'La generazione del video è in coda.',
    video_fail_generation:
      'Spiacenti, la generazione del video è fallita. Per favore riprova.',
    video_currently_generated:
      'Questo video è attualmente in fase di generazione.',
    checking_status: 'Controllo dello stato',
    check_status: 'Controlla stato',
    browser_does_not_support_audio: 'Il tuo browser non supporta il tag audio',
    existing_edit_scenario:
      'Vuoi modificare lo scenario esistente o crearne uno nuovo? Se crei uno nuovo, perderai il vecchio scenario.',
    generate_scenario: 'Genera scenario',
    layout: 'Layout',
    confirm_change: 'Conferma modifica',
    generated_ai_creation_message:
      'Nota che solo gli elementi di testo generati dalla creazione AI saranno mantenuti. Tutti gli altri elementi verranno rimossi dalla pagina.',
    generate_story: 'Genera storia',
    save_original_content: 'Salva contenuto originale:',
    story_added_specified_position:
      'La posizione della storia nella lezione. La storia sarà aggiunta come blocco nella posizione specificata.',
    position_of_story: 'Posizione della storia',
    start_the_lesson: 'Inizio della lezione',
    end_the_lesson: 'Fine della lezione',
    add_story_pages: 'Aggiungi storia alle pagine',
    browser_does_not_support: 'Il tuo browser non supporta l’elemento audio.',
    no_video_available: 'Nessun video disponibile.',
    no_podcast_available: 'Nessun podcast disponibile.',
    no_item_baskets: 'Nessun articolo nel carrello.',
    ai_course_object: 'Navigare nella leadership digitale'
  },
  v2: {
    n_data: 'Nessun dato',
    change: 'Cambia',
    remove: 'Rimuovi',
    auto_background: 'Sfondo automatico',
    create_new_course_org: 'Crea un nuovo corso per la tua organizzazione.',
    create_new_course_marketplace: 'Crea un nuovo corso per il marketplace.',
    create_new_course_both:
      'Crea un nuovo corso sia per la tua organizzazione che per il marketplace.',
    ok: 'Ok',
    page_bg: 'Sfondo pagina',
    lesson_cover: 'Immagine di copertina della lezione',
    create_skill_journey: 'Crea un percorso di competenze',
    Metamaze: 'Metamaze',
    events: 'Eventi',
    scroms: 'SCORM',
    min_score_pass: 'Punteggio minimo per superare',
    no_scorms_available: 'Nessun SCORM disponibile.',
    no_events_available: 'Nessun evento disponibile.',
    no_courses_available: 'Nessun corso disponibile.',
    no_courses_baskets: 'Nessun corso nel carrello.',
    no_mazes_baskets: 'Nessun labirinto nel carrello.',
    no_scroms_baskets: 'Nessun SCORM nel carrello.',
    no_events_baskets: 'Nessun evento nel carrello.',
    sorry: 'Spiacenti!',
    option_1: 'Opzione 1',
    option_2: 'Opzione 2',
    enter_number_words: 'Inserisci il numero massimo di parole.',
    summarize: 'Riassumi',
    answer: 'Risposta',
    hold_tight_one_minute:
      'Attendi! Stiamo ancora preparando. Potrebbe richiedere fino a un minuto.',
    enter_question: 'Inserisci la tua domanda.',
    enter_relevant_documents: 'Inserisci il numero di documenti rilevanti.',
    please_input_relevant_documents:
      'Per favore inserisci il numero corretto di documenti!',
    please_wait_loading_results: 'Attendere il caricamento dei risultati...',
    proceed_to_add_voice: 'Procedi ad aggiungere la voce',
    results: 'Risultati',
    no_result_found_try_asking_questions:
      'Nessun risultato trovato. Prova a fare più domande.',
    eg: 'es.,',
    what_make_sales_manager:
      'Cosa può farmi diventare un responsabile vendite?',
    please_select_lang: 'Per favore seleziona una lingua!',
    search: 'Cerca',
    please_copy_desired_content:
      'Per favore copia il contenuto desiderato dalla casella a sinistra a quella a destra.',
    rating_req: 'La valutazione è un campo obbligatorio.',
    review_req: 'La recensione è un campo obbligatorio.',
    rating_review_req: 'Devi fornire sia una valutazione che una recensione.',
    how_rate_this: 'Come valuteresti questo?',
    amazing_above_expectations: 'Fantastico! Oltre le aspettative!',
    certificates: 'Certificati',
    you_no_certificates: 'Al momento non hai certificati disponibili.',
    please_add_review:
      'Per favore fornisci una recensione insieme alla valutazione, grazie!',
    post: 'Pubblica',
    rate: 'Valuta',
    avg_rating: 'Valutazione media',
    no_review_found: 'Nessuna recensione trovata',
    are_sure_to_disale_zoom_integration:
      "Sei sicuro di voler disabilitare l'integrazione Zoom?",
    badges: 'Distintivi',
    you_no_badge_available: 'Al momento non hai distintivi disponibili.',
    download_certificate: 'Scarica certificato',
    loading: 'Caricamento in corso...',
    no_file_attached: 'Nessun file allegato',
    you_do_not_have_any_notes: 'Non hai appunti.',
    question: 'Domanda',
    score: 'Punteggio',
    alert_score_message: 'La/le persona/e ha/hanno inviato il punteggio.',
    alert_question_message: 'Non sono state aggiunte domande fino ad ora.',
    button_submit: 'Invia',
    button_allScores: 'Tutti i punteggi sono stati inviati.',
    record_wait: 'La registrazione sta iniziando. Attendere prego...',
    buttonSubmit_warning:
      'Per favore inserisci tutti i punteggi prima di inviare.',
    upload_ar_assets: 'Carica risorse AR',
    edit_ar_assets: 'Modifica risorse AR',
    edit_maze_assets: 'Modifica risorse MetaMaze',
    upload_assets: 'Carica risorse',
    upload_maze_assets: 'Carica risorse MetaMaze',
    trigger_title: 'Titolo trigger',
    model_title: 'Titolo modello',
    trigger_description: 'Descrizione trigger',
    model_description: 'Descrizione modello',
    please_type_target_description: 'Inserisci la descrizione del trigger.',
    please_type_model_description: 'Inserisci la descrizione del modello.',
    trigger_image: 'Immagine trigger*',
    model_image: 'Immagine modello*',
    upload_trigger_image: 'Carica immagine trigger',
    upload_model_image: 'Carica immagine modello',
    drag_n_drop: 'Trascina e rilascia',
    file_size_should_not_exceed:
      "(La dimensione dell'immagine non deve superare i 512 KB)",
    zip_size_should_not_exceed:
      '(La dimensione del file ZIP non deve superare i 60 MB)',
    ar_content: 'Contenuto AR*',
    model_content: 'Modello 3D*',
    upload_3d_zip: 'Carica ZIP / video',
    upload_3d_maze_zip: 'Carica ZIP',
    audio_content: 'Contenuto audio',
    _mp3: '(.mp3)',
    content_attached: 'ZIP allegato.',
    video_attached: 'Video allegato.',
    audio_attached: 'Audio allegato.',
    enter_trigger_image_title: "Inserisci un titolo per l'immagine trigger.",
    enter_model_title: 'Inserisci un titolo per il modello MetaMaze.',
    ar_preview_image: 'Immagine anteprima AR',
    upload_preview_image: 'Carica immagine anteprima',
    upload_audio: 'Carica audio',
    creating___: 'Creazione in corso...',
    updating___: 'Aggiornamento in corso...',
    create: 'Crea',
    update: 'Aggiorna',
    ar_assets: 'Immagini 3D',
    _3d_files_mp4: '(ZIP .obj, .fbx o video .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'Sono supportati solo file .jpg',
    persons_have_submitted_their_scores:
      'gli utenti hanno inviato i loro punteggi.',
    no_questions_added_till_now: 'Nessuna domanda aggiunta finora.',
    submit: 'Invia',
    all_scores_submitted: 'Tutti i punteggi sono stati inviati.',
    recording_is_starting:
      'La registrazione sta per iniziare. Attendere prego...',
    please_input_scores_before_submitting:
      'Inserisci tutti i punteggi prima di inviare.',
    end_for_all: 'Termina per tutti',
    full_screen: 'Schermo intero',
    breakout_room: 'Stanza secondaria',
    send_invitations: 'Invia inviti',
    add_participants: 'Aggiungi partecipanti',
    create_breakout_room: 'Crea stanza secondaria',
    connecting: 'Connessione in corso...',
    currently_broadcaster_unavailable:
      'Il trasmettitore non è attualmente disponibile.',
    how_many_breakout_room_to_create: 'Quante stanze secondarie vuoi creare?',
    create_upto_three_breakout_rooms: '*Puoi creare fino a 3 stanze secondarie',
    allow: 'Consenti',
    additional: 'Aggiuntivo',
    attachment: 'Allegato',
    no_description_available: 'Nessuna descrizione disponibile.',
    people: 'Persone',
    waiting: 'In attesa',
    hand_raising_users: 'Utenti con la mano alzata',
    invite: 'Invita',
    create_room: 'Crea stanza',
    create_live_event: 'Crea evento live',
    support_upto_fivethousand_participants: 'Supporta fino a 5000 partecipanti',
    support_upto_ten_participants: 'Supporta fino a 10 partecipanti video',
    support_upto_twohundred_participants: 'Supporta fino a 200 partecipanti',
    supprt_upto_five_participants: 'Supporta fino a 5 partecipanti video',
    support_upto_twentyfive_participants:
      'Supporta fino a 25 partecipanti video',
    two_live_video_participants: '2 partecipanti video (host e ospite)',
    you_can_have_upto_five_examinees: 'Puoi avere fino a 5 esaminandi.',
    you_can_have_upto_twentyfive_participants:
      'Puoi avere fino a 25 partecipanti.',
    you_can_have_upto_five_participants: 'Puoi avere fino a 5 partecipanti.',
    you_can_have_upto_ten_participants: 'Puoi avere fino a 10 partecipanti.',
    select_hosts_email: 'Seleziona email host',
    send_invite_email: 'Invia email di invito',
    do_not_send_invite_email: 'Non inviare email',
    error: 'Errore',
    max_twentyfive_users_allowed: 'Puoi selezionare al massimo 25 utenti',
    max_five_users_allowed: 'Puoi selezionare al massimo 5 utenti',
    max_ten_users_allowed: 'Puoi selezionare al massimo 10 utenti',
    no_user_found: 'Nessun utente trovato',
    transcribe_to: 'Trascrivi in',
    integrate_zoom_to_start_meeting: 'Integra Zoom per avviare la riunione.',
    zoom_is_not_integrated: 'Zoom non è integrato.',
    delete_poll: 'Elimina sondaggio',
    add_poll: 'Aggiungi sondaggio',
    live_now: 'In diretta!',
    average_rating: 'Valutazione media',
    review: 'Recensione',
    time_spent: 'Tempo trascorso',
    total: 'Totale',
    mins: 'minuti',
    no_data: 'Nessun dato disponibile.',
    total_score: 'Punteggio totale',
    pass_score: 'Punteggio minimo',
    point: 'punto',
    wrong: 'sbagliato',
    response: 'risposta',
    submitted: 'inviato',
    average: 'media',
    total_play: 'Riproduzioni totali',
    view_graph: 'Visualizza grafico',
    time_spent_mins: 'Tempo (in minuti)',
    play: 'Riproduci',
    ideal_path: 'Percorso ideale',
    user_incorrect_path: 'Percorso errato utente',
    ideal_path_taken: 'Percorso ideale seguito',
    scenario: 'Scenario',
    option: 'Opzione',
    spend: 'Tempo impiegato',
    average_spending_time: 'Tempo medio impiegato',
    activity_overview: 'Panoramica attività',
    live_event: 'Evento live',
    live_assessment: 'Valutazione live',
    report_download: 'Scarica report',
    all_workshops: 'Tutti i workshop',
    overview_average_activity: 'Panoramica attività media',
    overview_workshop_graph: 'Grafico del workshop',
    mazes: 'Percorsi',
    correct_feedback: 'Feedback corretto',
    incorrect_feedback: 'Feedback errato',
    checkin_checkout: 'Check-in Check-out',
    minutes: 'minuti',
    incorrect_path: 'Percorso errato',
    answer_not_available: 'Risposta non disponibile',
    views: 'Visualizzazioni',
    item: 'Elemento',
    questions: 'Domande',
    total_points: 'Punti totali',
    total_attempts: 'Tentativi totali',
    created_date: 'Data creazione',
    host_name: 'Nome host',
    host_section: 'Sezione host',
    choose_products: 'Scegli prodotti',
    add_to_basket: 'Aggiungi al carrello',
    basket: 'Carrello',
    times: 'volte',
    scorms: 'SCORMs',
    skill_journey_overview: 'Panoramica del percorso di apprendimento',
    how_to_use: 'Come usare',
    live_broadcast_description:
      'Abbiamo integrato le trasmissioni live in uno strumento di creazione corsi facile da usare.',
    live_broadcast_subdescription:
      'Con il sistema di trasmissione live di ShareLook, puoi aumentare il coinvolgimento, l’automazione e la condivisione della conoscenza.',
    disclaimer: `Certifico che il mio percorso di apprendimento:
- Non viola i diritti di terzi
- Non contiene contenuti illegali (diffamatori, nudità, violenza, discriminazione)
- Non è un attacco personale
- Non impersona un’altra identità
- Non registra informazioni private senza consenso
- Non è spam o pubblicità`,
    price: 'Prezzo',
    video_link: 'Link video',
    category: 'Categoria',
    objectives: 'Obiettivi',
    marketplace_description: 'Descrizione del marketplace',
    live_discussion: 'Discussione live',
    poll: 'Sondaggio',
    hide_grid: 'Nascondi griglia',
    show_grid: 'Mostra griglia',
    stop_screen_share: 'Interrompi condivisione schermo',
    screen_share: 'Condividi schermo',
    mute: 'Silenzia',
    unmute: 'Attiva audio',
    raise_hand: 'Alza la mano',
    waiting__: 'In attesa...',
    audio_active: 'Audio attivo'
  },

  general: {
    save: 'Salva',
    autosaved: 'Autosalvataggio',
    back_to: 'Torna A',
    by: 'Da',
    chat: 'Chat',
    completed: 'Completato',
    canceled: 'Cancellato',
    component: 'Componente',
    confirm: 'Conferma',
    course: 'Corso',
    skill: 'Percorso di Abilità',
    maze: 'MetaLabirinto',
    channel: 'Canale',
    podcast: 'Podcast',

    date: 'Data',
    details: 'Dettagli',
    empty: 'No dati',
    enrolled: 'Registrato',
    free: 'Gratuito',
    graph: 'Grafico',
    loading: 'Caricamento…',
    lesson: 'Lezione',
    lessons: 'Lezioni',
    live_assessment: 'Valutazione Diretta',
    live_event: 'Evento Diretta',
    no: 'No',
    of: 'Di',
    or: 'O',
    organization: 'Organizzazione',
    page: 'Pagina',
    pages: 'Pagine',
    personal: 'Personale',
    poll: 'Sondaggio',
    rating: 'Valutazione',
    reset: 'Ripristina',
    signin: 'Registrati',
    signup: 'Regsitrati',
    soon: 'Presto',
    type: 'Tipo',
    uploading: 'Caricamento In Corso…',
    yes: 'Si',
    something_went_wrong: ' Qualcosa È Andato Storto!',
    view_all: 'Vedi Tutto',
    upload_successful: 'Caricato Con Successo',
    upload_successful_message: `I Vostri Documenti Excel Sono Stati Caricati Con Successo E Sono In Fase Di Elaborazione. Questo Potrebbe Richiedere Un Po' Di Tempo.`,
    check_email_upload_successful:
      'Per Favore <0>Controlla La Tua Email</0> Per Il <1>Report</1> Della Lista Degli Utenti Caricati',
    is_private: 'Privato'
  },

  account: {
    title: 'Account',
    subtitle: 'Gestisci Le Tue Impostazioni E Le Informazioni Sul Conto.',
    saved: 'Account Cambiato Con Successo'
  },

  assessments: {
    title: 'Valutazioni',
    subtitle: 'Crea Una Valutazione',
    finished: 'La Valutazione È Finita',
    countdown: 'La Valutazione In Diretta Verrà Trasmessa In',
    create: 'Crea Valutazione',
    list_title: 'Crea Le Tue Valutazioni',
    delete_warning: 'Sei Sicuro Di Voler Cancellare Questo Elemento?',
    details_title: 'Aggiungi Dettagli Valutazione',
    details_subtitle:
      'Date Un Nome Alla Vostra Valutazione E Dite Al Vostro Pubblico Cosa Si Aspetta Di Imparare Da Essa',
    disclaimer: `Garantisco Che La Mia Valutazione Registrata Non Farà Le Seguenti:
  - Violi I Diritti Di Terzi
  - Contenere Contenuti Illegali, Compresi Quelli Diffamatori, Osceni, Indecenti, Lascivi, Pornografici, Violenti, Abusivi, Ingiuriosi, Minacciosi O Discriminatori, Anche Travestiti Da Asterischi
  - Contenere Eventuali Attacchi Personali Ad Altre Persone
  - Contenere L'eventuale Impersonificazione Di Altri Partecipanti, Personaggi Pubblici O Celebrità
  - Contenere Qualsiasi Registrazione O Informazione Personale Su Qualsiasi Individuo Senza Il Consenso Di Tale Individuo E Non Viola Alcuna Normativa Sulla Protezione Dei Dati In Nessuna Parte Del Mondo
  - Contenere Qualsiasi Sollecitazione Commerciale O Qualsiasi Forma Di "Spam"`,
    assessment_details: 'Dettagli Valutazione',

    assessment_settings: 'Impostazioni Valutazione'
  },

  buildersettings: {
    title: 'Impostazioni Di Pubblicazione',
    subtitle:
      'Aggiungete le impostazioni al vostro evento, che possono visualizzare e interagire con il vostro evento.'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Aggiungi',
    add_page: 'Aggiungi Pagina',
    add_lesson: 'Aggiungi Lezioni',
    add_answer: 'Aggiungi Nuova Risposta',
    add_group: 'Aggiungi Gruppo',
    add_organization: 'Aggiungi Organizzazione',
    add_question: 'Aggiungi Domanda',
    add_quiz: 'Aggiungi Quiz',
    add_users: 'Aggiungi Utenti',
    back: 'Dietro',
    back_to_course: 'Torna Alla Panoramica Del Corso',
    back_to_lesson: 'Torna Alla Panoramica Della Lezione',
    back_to_media: 'Torna Alla Libreria Media',
    back_to_details: 'Torna Ai Dettagli',
    cancel: 'Cancella',
    clear: 'Pulisci',
    close: 'Chiudi',
    clone: 'Clona',
    close_lesson: 'Chiudi Lezione',
    clone_course: 'Chiudi Clone',
    confirm: 'Conferma',
    create: 'Crea',
    download: 'Scarica',
    download_mass_user_tamplate: 'Scarica Stampo',
    add_mass_users: 'Aggiungere Utenti Di Massa',
    upload_excel_list: 'Carica Lista Excel',
    delete: 'Cancella Media',
    edit: 'Modifica',
    edit_course: 'Modifica Corso',
    enroll: 'Iscriviti',
    finish: 'Finisci',
    upload_image: 'Carica Immagine',
    upload_image_video: 'Carica Immagine O Video',
    select_media_library: 'Seleziona Libreria Media',
    make_public: 'Rendi Pubblico',
    make_private: 'Rendi Privato',
    make_org: 'Crea Organizzazione',
    media: 'Libreria Media',
    my_theme: 'Il Mio Tema',
    next: 'Prossimo',
    next_lesson: 'Prossima Lezione',
    next_step: 'Prossima Fase',
    previous_step: 'Fase Precedenti',
    publish: 'Pubblica',
    publish_assessment: 'Pubblica La Tua Valutazione',
    publish_course: 'Pubblica Il Tuo Corso',
    publish_event: 'Pubblica Il Tuo Evento',
    reset: 'Resetta',
    reset_elements: 'Resetta elementi',
    save: 'Salva',
    creating: 'Creando...',
    updating: 'Aggiornando…',
    saved: 'Salvato',
    save_for_later: 'Salva Per Dopo',
    save_settings: 'Salva Impostazioni',
    select_files: 'Seleziona Files',
    select_theme: 'Seleziona Tema',
    start_lesson: 'Inizia Lezione',
    update: 'Aggiorna',
    upload: 'Carica',
    upload_audio: 'Carica Audio',
    upload_photo: 'Carica Una Foto Profilo',
    upload_video: 'Carica Video',
    enrolled: 'Iscriviti',
    unenroll: 'Disiscriviti',
    from_library: 'Libreria Media',
    remove: 'Rimuovi',
    removed: 'Rimosso',
    start_broadcast: 'Inizia Trasmissione',
    end_broadcast: 'Fine Trasmissione',
    camera: 'Camera',
    screen: 'Scherno',
    screen_with_camera: 'Scherno con Camera',
    insert: 'inserito',

    inserting: 'Inserimento'
  },

  card: {
    quick_add: 'Aggiunta Veloce',
    add: 'Aggiungi',
    clone: 'Clona',
    completed: 'Lezioni Completate'
  },

  course: {
    upcoming_course: 'Prossimo Corso',
    unPublishEvent: 'Evento Non pubblicato',
    unPublishAssessment: 'Valutazione Non pubblicata',
    pastCourse: 'Corso Di Formazione',
    upcoming: 'Prossimo Evento Diretta',
    pastEvent: 'Evento Diretta Passato',
    pastAssessment: 'Valutazione Diretta Passata',
    upcomingAssessment: 'Prossima Valutazione Diretta',
    created: 'Data Creata',
    assignees: 'Assegnatari',
    organisations:
      '{{{ Organizzazioni }}} Organizzazioni, <2> {{ Utenti }} Utenti</2>',
    event_date: `Data Dell'evento Diretta <1> {{ Data }} </1>`,
    delete_warning: 'Sei Sicuro Di Volerlo Cancellare',
    clonning_no_lesson:
      'Si Prega Di Aggiungere Almeno Una Lezione Per Clonare Questo Corso',
    clone_warning: 'Sei Sicuro Di Voler Clonare Questo',
    clone_success: 'È In Processo Di Clonazione',
    disclaimer: `Garantisco Che Il Mio Corso Non Farà Le Seguenti:
  - Violare I Diritti Di Terzi
  - Contenere Contenuti Illegali, Compresi Quelli Diffamatori, Osceni, Indecenti, Lascivi, Pornografici, Violenti, Abusivi, Ingiuriosi, Minacciosi O Discriminatori, Anche Travestiti Da Asterischi
  - Contenere Eventuali Attacchi Personali Ad Altre Persone
  - Contenere L'eventuale Impersonificazione Di Altri Partecipanti, Personaggi Pubblici O Celebrità
  - Contengano Informazioni Personali Su Qualsiasi Persona Senza Il Consenso Di Quest'ultima E Non Violino Le Norme Sulla Protezione Dei Dati Personali In Nessuna Parte Del Mondo
  - Contenere Qualsiasi Sollecitazione Commerciale O Qualsiasi Forma Di "Spam"`
  },

  coursecreate: {
    dropzone_text: 'Inserire Media',
    sidebar_text: 'Seleziona Un Tema <1/> Per Le Tue Lezioni <3/>',
    delete_warning: 'Sei Sicuro Di Voler Cancellare Questa Lezione?'
  },

  coursepage: {
    quizview_loading: 'Controllo Delle Risposte. Si Prega Di Attendere...',
    quizview_answer: 'La Tua Risposta'
  },

  coursequiz: {
    title: 'Quiz In Tutte Le Lezioni'
  },

  dashboard: {
    tooltip_title: 'Non Mostrare Più Questo Video',
    page_title: 'La Statistica Dei Tuoi Corsi',
    page_subtitle: 'Stato Dei Corsi Da Voi Creati',
    profile_add_info:
      'Aggiungi Il Tuo <1>{{{{Uncompletedtext}}</1> Per Completare Il Tuo Profilo',
    profile_build:
      'Costruisci Il Tuo Profilo <1>Qui</1>, Facci Conoscere I Tuoi Interessi E Le Tue Capacità',
    profile_title: 'Forza Del Profilo',
    more_details: 'Più Dettagli'
  },

  errors: {
    answer: 'Si Prega Di Inserire La Risposta',
    answer_correct: 'Scegliere La Risposta Corretta',
    code: 'Si Prega Di Inserire Il Codice',
    criterion: 'Si Prega Di Inserire Il Criterio',
    duration: 'La Durata È Obbligatoria',
    element: `Si Prega Di Inserire L'elemento`,
    email: 'Inserisci La Tua E-Mail',
    email_invalid: `'L'input Non È Un'e-Mail Valida`,
    feedback_correct: 'Si Prega Di Inserire Il Feedback Corretto',
    feedback_incorrect: 'Il Feedback Inserito È Errato',
    host: `Si Prega Di Inserire L'ospitante Dell'evento`,
    host_assessment: 'Si Prega Di Inserire L’ospitante Di Valutazione',
    image: `Si Prega Di Caricare Un'immagine`,
    location: 'Inserisci La Tua Posizione',
    live_location: 'Si Prega Di Scegliere Un Luogo Di Trasmissione',
    limit: 'Si Prega Di Inserire I Minuti Di Live-Streaming',
    min_3char: 'Minimo 3 Caratteri',
    number: 'Si Prega Di Inserire Il Numero Positivo',
    host_email_require: `Le E-Mail Dell'ospitante Sono Necessarie`,
    attendee_email_require: 'Le Email Dei Partecipanti Sono Richieste',
    name: 'Per Favore Inserisci Il Tuo Nome',
    not_found_course: 'Corso Non Trovato',
    not_found_event: 'Evento Non Trovato',
    not_found_assessment: 'Valutazione Non Trovata',
    password: 'Per Favore Inserisci La Tua Pasword',
    password_digit: 'Almeno Una Cifra',
    password_short: 'La Password È Troppo Corta, Minimo 10 Caratteri',
    password_special: 'Almeno Un Carattere Speciale',
    password_uppercase: 'Almeno Un Carattere In Maiuscolo',
    password_lowercase: 'Almeno Un Carattere In Minuscolo',
    phone: 'Per Favore Inserisci Il Tuo Telefono',
    phone_invalid: 'Numero Di Telefono Non Valido',
    position: 'Inserisci La Tua Posizione',
    question: 'Si Prega Di Inserire La Domanda',
    start_date: 'Data E Tempo Di Inizio Sono Richiesti',
    tag: `Si Prega Di Selezionare Un'etichetta`,
    topics: 'Si Prega Di Selezionare Almeno Un Argomento',
    live_topics: 'Si Prega Di Aggiungere Argomenti',
    title: 'Si Prega Di Inserire Il Titolo',
    title_assessment: 'Si Prega Di Inserire Il Titolo Di Valutazione',
    title_course: 'Si Prega Di Inserire Il Titolo Del Corso',
    title_empty: 'Il Titolo Non Può Essere Vuoto',
    title_event: `Si Prega Di Inserire Il Titolo Dell'evento`,
    title_lesson: 'Si Prega Di Inserire Il Titolo Della Lezione',
    title_quiz: 'Si Prega Di Inserire Il Nome Del Quiz',
    username: 'Inserisci Il Tuo Nome Utente',
    invalid_verification_code: 'Questo link di verifica è scaduto o non è più valido. Ciò accade solitamente se è stata richiesta un\'email di verifica più recente. Controlla l\'email più recente ricevuta da Sharelook per verificare il tuo indirizzo email.',
    upload_error: ' Errore - File Non Compatibile',
    upload_more_than_10:
      'È Possibile Caricare Solo Un Massimo Di 10 File Alla Volta',
    topics_max: 'Si Prega Di Aggiungere 3 Argomenti Al Massimo',
    upload_excel: 'Si Prega Di Assicurarsi Di Aver Caricato Il File Corretto',
    title_excel: 'Errore Nel Caricamento Del Modello',
    file_size_exceed: 'La Dimensione Del File Supera Il Limite',
    subtitle_excel:
      'Si Prega Di Assicurarsi Di Utilizzare Il Modello Fornito E Di Compilare Correttamente Le Colonne',
    select_broadcast_option: `Si Prega Di Selezionare Un'opzione Per La Trasmissione Di Questo Evento`,
    multi_hosts_number_error: `Il Numero Del Presentatore Non Può Superare Quello Specificato Per L'evento`,
    conference_people_number_error: `Il Numero Di Partecipanti Non Può Superare Quello Specificato Per L'evento`,
    select_max_host: `Selezionare Almeno 1 Presentatore Per L'evento`,
    select_max_conference: `Selezionare Almeno 1 Partecipante Per L'evento`,
    stream_stop_error: 'Lo Streaming Si È Fermato Inaspettatamente!',
    unsecure_context: `Errore Fatale: Il Browser Non Può Accedere Alla Fotocamera E Al Microfono A Causa Del Contesto Non Sicuro. Si Prega Di Installare SSL E L'accesso Tramite Https`,
    ws_not_supported:
      'Errore Fatale: Websocket Non È Supportato In Questo Browser',
    no_org: 'Selezionare almeno 1 organizzazione per procedere',
    no_org_group:
      'Selezionare almeno 1 gruppo di organizzazioni per procedere.',
    waiting_to_join: 'Aspetto che qualcuno si unisca!'
  },

  events: {
    title: `Aggiungi Dettagli Dell'evento In Diretta`,
    change_host: 'Cambia Ospite',
    finished: `L'evento È Finito`,
    countdown: `L'evento In Diretta Sarà Trasmesso In`,
    subtitle:
      'Date Un Nome Al Vostro Evento Diretta E Dite Al Vostro Pubblico Cosa Si Aspetta Di Imparare Da Esso',
    poll_disabled: `Garantisco Che Il Mio Evento Registrato Non Farà Le Seguenti:
  - Infrangere I Diritti Di Terzi
  - Contenere Contenuti Illegali, Compresi Quelli Diffamatori, Osceni, Indecenti, Lascivi, Pornografici, Violenti, Abusivi, Ingiuriosi, Minacciosi O Discriminatori, Anche Travestiti Da Asterischi
  - Contenere Eventuali Attacchi Personali Ad Altre Persone
  - Contenere L'eventuale Impersonificazione Di Altri Partecipanti, Personaggi Pubblici O Celebrità
  - Contenere Qualsiasi Registrazione O Informazione Personale Su Qualsiasi Individuo Senza Il Consenso Di Tale Individuo E Non Viola Alcuna Normativa Sulla Protezione Dei Dati In Nessuna Parte Del Mondo
  - Contengono Qualsiasi Sollecitazione Commerciale O Qualsiasi Forma Di "Spam"`,

    prompt_message:
      'Lasciando Questa Pagina, Il Vostro Evento Sarà Terminato. Sei Sicuro Di Voler Lasciare Questa Pagina?',
    duration_exceed_message: `Il Tuo Tempo Di Trasmissione Supera, l'App Smetterà Di Trasmettere.`,
    before_schedule_message: `State Per Iniziare La Trasmissione Prima Dell'orario Previsto Per L'evento. Si Prega Di Notare Che L'interruzione Della Trasmissione Porrà Fine All'evento.`,
    browser_unsupportive_message:
      'Il Tuo Browser Non Supporta La Condivisione Dello Schermo. Potete Vedere I Browser Supportati In Questo Link',
    cancel_switch_host_message: `L'host Non È Disponibile. L'evento Continuerà Dalla Vostra Fine`,
    coaching_prompt_message: `Non È Possibile Lasciare Questa Pagina Fino Alla Fine Dell'evento`,
    event_modal_warn: 'Vuoi Lasciare Questo Evento?',
    confirm_message: 'Il Vostro Evento Terminerà Se Cliccate Su OK',
    screen_share_denied: 'Hai Negato Di Condividere Il Tuo Schermo',
    media_not_found:
      'La Fotocamera O Il Microfono Non Si Trovano O Non Sono Ammessi Nel Dispositivo',
    Media_Not_Access:
      'La Fotocamera O Il Microfono È Utilizzato Da Qualche Altro Processo Che Non Permette di leggere i dispositivi',
    constraint_error:
      'Non È Stato Trovato Alcun Dispositivo Che Si Adatti Ai Vostri Vincoli Video E Audio. È Possibile Modificare I Vincoli Video E Audio',
    media_access_denied: `Non È Consentito L'accesso Alla Telecamera E Al Microfono.`
  },

  filters: {
    days7: 'Ultimi 7 Giorni',
    days15: 'Ultimi 15 Giorni',
    days30: 'Ultimi 30 Giorni',
    days365: 'Ultimi 365 Giorni',
    date: 'Data Creata',
    relevance: 'Rilivanza',
    popularity: 'Popolarità',
    name: 'Nome',
    group: 'Gruppo',
    Newest_to_Oldest: 'Dal più Nuovo al più Vecchio',
    Oldest_to_Newest: 'Dal più Vecchio al più Nuovo',
    A_Z: 'A alla Z',
    Z_A: 'Z a A'
  },

  helpers: {
    password:
      'Per Garantire La Sicurezza Del Tuo Conto Abbiamo Bisogno Di Almeno Un Numero Minuscolo Nella Tua Password. È Inoltre Necessario Avere Una Lunghezza Minima Di 10 Caratteri',
    phone:
      'Si Prega Di Includere Ad Esempio Il Prefisso Del Paese In Cui Si Trova Il Telefono: +65',
    username:
      'Il Tuo Nome Utente Viene Trattato Come Informazione Pubblica E Condiviso Con Altri Utenti A Seconda Delle Necessità. Come Tale, Si Consiglia Di Non Utilizzare Informazioni Personali Nel Proprio Nome Utente',
    public_description_normal: `Il Tuo <0><0/></0> È Stato Salvato Ed È Considerato Privato Per Impostazione Predefinita. Ciò Significa Che Solo Tu Puoi Vedere Questo Contenuto. Per Pubblicare Questo Contenuto È Possibile Selezionare Una Delle Opzioni Seguenti. Pubblicare Il Tuo Corso Al Pubblico Significa Che Sarà Disponibile Per Tutti Gli Utenti Della Piattaforma. L'opzione Utenti Specifici Ti Permetterà Di Condividere Il Tuo Corso Con Utenti Specifici Utilizzando L'indirizzo E-Mail Associato Al Loro Account Sharelook.`,
    public_description_admin: `Questo <0><0/></0> È Stato Salvato Ed È Considerato Privato Per Impostazione Predefinita. Questo Significa Che Solo Tu (E Il Creatore Del Contenuto) Puoi Vedere Questo Contenuto. Per Pubblicare Questo Contenuto È Possibile Selezionare Una Delle Opzioni Seguenti. Pubblicare Il Tuo Corso Al Pubblico Significa Che Sarà Disponibile Per Tutti Gli Utenti Della Piattaforma - Compresi Quelli Al Di Fuori Della Tua Organizzazione. Pubblicarlo All'organizzazione Significa Che Tutti Gli Utenti All'interno Dell'organizzazione Potranno Vederlo. Potete Anche Pubblicarlo A 1 O Più Gruppi, Il Che Significa Che Solo Gli Utenti All'interno Di Tali Gruppi Potranno Vederlo.  Infine, Avete La Possibilità Di Pubblicarlo A Specifici Utenti All'interno E All'esterno Della Vostra Organizzazione Utilizzando L'indirizzo E-Mail Del Loro Account Sharelook.`
  },

  labels: {
    add: 'Aggiungi',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Tipo Di Risposta',
    answers: 'Risposte',
    back_to_quiz: 'Torna Alla Lista Quiz',
    back_to_question: 'Torna Alla Lista Domande',
    chat: 'Chat',
    chat_available: 'La Chat Non È Disponibile In Questo Evento',
    chat_report: 'Chat Report',
    choice_single: 'Scelta Singola',
    choice_multiple: 'Scelta Multipla',
    choice_free: 'Scelta “Libera”',
    choice_sorting: 'Scelta “Ordinamento”',
    choice_matrix: 'Scelta “Ordinamento Matrice”',
    clone_lesson_permission: 'Permesso Di Clonazione',
    code: 'Codice',
    correct: 'Correto',
    created: 'Data Creata',
    clone_modal: 'Clona Corso',
    cloning_course: 'Clonando Corso...',
    cloning: ' Clonando…',
    cloning_course_desc:
      'Questo Processo Richiederà Del Tempo. Per Favore Sii Paziente',
    cloning_success: 'Il Corso "<0/>" È Stato Clonato Con Successo!',
    description: 'Descrizione',
    disclaimer: 'Avvertenza',
    drop_file: ' Lascia File Qui…',
    duration: 'Durata',
    edit: 'Modifica',
    email: 'Email',
    event: 'Evento',
    event_all: 'Tutti I Suoi Eventi',
    event_date: 'Data/Tempo Locale Evento Diretta',
    event_this: 'Quest’ Evento',
    expire: 'Scade Il',
    expiry_date: 'Data Di Scadenza',
    forgot: 'Password Dimenticata?',
    group: 'Gruppo',
    groups_list: 'Lista Di Gruppi',
    host: 'Ospitante',
    id_annotation: 'Annotazione ID',
    id_quiz: 'Quiz ID',
    incorrect: 'Incorreto',
    interests: 'Interessi',
    invited: 'Invitato',
    live_chat: 'Discussione Diretta',
    live_stream_limit: 'Minuti Live-streaming',
    contact_text:
      'Per Modificare Il Limite Mensile Di Live-Streaming Si Prega Di Contattare',
    contact_admin:
      '<0>Se Desiderate Modificare Il Vostro Limite Mensile Di Live-Streaming Contattate</0> <1>Admin@Sharelook.Com</1>',
    limit_stream_text:
      ' Live-Streaming Minuti Rimanenti: <0>{{ Limite }}}</0> Minuti <1/><2/> <3> Per Modificare Il Limite Mensile Di Live-Streaming Si Prega Di Contattare</3> <4>Admin@Sharelook.Com</4>',
    location: 'Locazione',
    lessons: 'Lezioni',
    location_broadcast: 'Posizione Del Server Host',
    location_broadcast_subtitle: `Aggiungete Una Posizione Che Sia La Più Vicina Alla Posizione Dell'ospite Della Trasmissione Per Ridurre Il Ritardo Audiovisivo`,
    media_manager: 'Gestore Media',
    minutes: 'Minuti',
    name: 'Nome',
    online_quiz: 'Quiz Online',
    organiser: 'Autore',
    organization: 'Organizzazione',
    overall_emotion: 'Esperienza In Generale',
    organizations_list: 'Lista Organizzazioni',
    password: 'Password',
    participants: 'Partecipanti',
    picture: 'Immagine (16:9)',
    phone: 'Telefono',
    photo: 'Foto',
    poll: 'Sondaggio',
    position: 'Posizione',
    processing: 'Processamento',
    privacy_settings: 'Impostazioni Privacy',
    question: 'Domanda',
    quiz_create: 'Crea Nuovo Quiz',
    quiz_name: 'Nome Quiz',
    quiz_update: 'Aggiorna Quiz',
    select_organization: 'Seleziona Organizzazione',
    settings: 'Impostazioni',
    show: 'Mostra',
    show_graph: 'Mostra Risultato Grafico',
    signin: 'Segnati',
    signup: 'Iscriviti',
    sort_by: 'Ordina Per',
    start_date: 'Data Inizio',
    tags: 'Etichette',
    terms: 'Accetto Questi <1>Termi E Condizioni</1>',
    title: 'Titolo',
    topics: 'Argomenti',
    topic: 'Argomento',
    total_comments: 'Commenti Totali',
    username: 'Nome Utente',
    users_list: 'Lista Utenti',
    users_emails: 'Inserire Email Specifiche Per Gli Utenti',
    description_specifiction_email:
      'Si Prega Di Inserire 1 Indirizzo E-Mail Per Riga Per Condividerlo Con Più Utenti Specifici.',
    message_specific_email: `Si prega di inserire un'e-mail dell'utente specifico.`,
    viewers: 'Visitatori',
    edit_course: 'Modifica',
    edit_assessment: 'Modifica',
    edit_event: 'Modifica',
    delete_course: 'Cancella',
    delete_event: 'Cancella',
    delete_assessment: 'Cancella',
    view_course: 'Vedi',
    view_event: 'Vedi',
    view_assessment: 'Vedi',
    date_event: 'Data evento Diretta',
    date_assessment: 'Data Valutazione Diretta',
    clone_of: 'Clona',
    clone_course: `Crea Un Clone Di Questo Corso Che Puoi Modificare Indipendentemente Dall'originale, Include Tutte Le Lezioni E Le Pagine`,
    make: 'Crea',
    available_to: 'Disponibile Per Qualsiasi Utente Di Sharelook',
    uploaded_by: 'Caricata Da',
    course: 'Corso',
    assessment: 'Valutazione',
    user_not_exist: `L'utente Non Esiste, Vuoi Inviare Un Invito?`,
    check_user: 'Avviso',
    user_not_exist_in_org: `L'utente Non Esiste In Questa Organizzazione, Volete Inviare Un Invito? `,
    title_modal_stream: `Cambiamento Del Limite Dell'organizzazione Livestream`,
    des_warning_stream: 'Stai Per Cambiare',
    monthly_stream: 'Limite Mensile Di Live-Streaming',
    min_per_month: 'Minuti/Mese',
    broadcast_label: 'Voglio Fare',
    hosts_emails: `Inserire L'indirizzo E-Mail Specifico Dell'host`,
    attendee_emails: 'Inserire Le E-Mail Dei Partecipanti',
    description_host_specifiction_email:
      'Si Prega Di Inserire 1 Indirizzo E-Mail Per Riga',
    presenter_label: 'Presentatore',
    presenter_label_conference: 'No. Di Persone',
    event_privacy: 'Modalità Conferenza'
  },

  broadcastOptions: {
    stream_from_phone: 'Trasmissione In Diretta Con Il Mio Telefono',
    other_webrtc: 'Webinar Dal Mio PC',
    multihost: 'Webinar Multicast Dal Mio PC',
    peer2peer: 'Sessione Di Coaching',
    conference: 'Conferenza Diretta'
  },

  lessoncreate: {
    title: 'Aggiungi Dettagli Lezione',
    subtitle:
      'Date Un Nome Alla Vostra Lezione E Dite Al Vostro Pubblico Cosa Si Aspetta Di Imparare Da Essa',
    input_label_title: 'Titolo Lezione',
    input_label_topics: 'Argomenti Lezione',
    input_label_description: 'Descrizione Lezione',
    delete_warning: 'Sei Sicuro Di Voler Cancellare Questa Pagina? '
  },

  lessonoverview: {
    title: 'Aggiungi Lezione',
    subtitle: 'Aggiungere Una Lezione Esistente O Crearne Una Nuova',
    new_lesson: 'Creare Una Nuova Lezione',
    new_lesson_sub: 'Creare Una Lezione Nuova Di Zecca Da Zero!',
    existing_lesson: 'Selezionare La Lezione Esistente',
    existing_lesson_sub:
      'Collegamento A Una Lezione Esistente, Le Modifiche Apportate A Questa Lezione Influenzeranno Anche Questa Lezione In Altri Corsi.',
    clone_lesson: 'Duplicare La Lezione Esistente',
    clone_lesson_sub:
      'Fai Una Copia Unica Della Lezione In Questo Corso, Le Modifiche Apportate A Questa Lezione Non Influenzeranno La Lezione Originale',
    clone_lesson_modal_sub:
      'Clicca Sul Pulsante "Clona" Sotto La Lezione Che Vuoi Aggiungere Al Tuo Corso.'
  },

  management: {
    groups_title: 'Gestisci Gruppi',
    delete_warning: 'Sei Sicuro?',
    organizations_title: 'Le Mie Organizzazioni',
    organizations_subtitle: 'Aggiungi Organizzazioni Alla Tua Lista',
    users_title: 'Gestire Gli Utenti',
    users_position: 'Gestore Account Senior',
    user_not_found: 'Utente Non Trovato',
    select_org: `Trovare E Scegliere Un'organizzazione Per La Gestione Degli Utenti`
  },

  audio: {
    modal_title: 'Inserisci Audio',
    list_view: 'Vista Lista',
    create_audio_modal_title: 'Crea Audio',
    edit_audio_modal_title: 'Modifica Audio',
    public_audio_not_found: 'Audio Non Trovato',
    private_audio_not_found: `Non Hai Ancora Caricato L'audio`,
    are_you_sure_to_delete: 'Sei Sicuro Di Voler Cancellare?',
    type_something: 'Digita Qualcosa',
    select_voice: 'Seleziona',
    file_name: 'Nome File',
    description: 'Descrizione',
    topic: 'Argomento',
    key_words_tag: 'Etichetta Parole chiave',
    mp3_audio: 'Audio Mp3',
    created: 'Creato',
    duration: 'Durata',
    close: ' chiudi '
  },

  image: {
    modal_title: 'Inserisci Immagine',
    image: 'Immagine',
    pixel: 'Pixel',
    dimension: 'Dimensione',
    public_image_not_found: 'Imagine Non Trovata',
    private_image_not_found: ' Non Hai Ancora Caricato Nessuna Immagine'
  },

  annotation: {
    modal_title: 'Annotazione'
  },

  text: {
    modal_title: 'Editor Testo'
  },

  video: {
    modal_title: 'Inserire Video',
    image: 'Video',
    mp4_video: 'Video Mp4',
    public_video_not_found: 'Video Non Trovato',
    private_video_not_found: 'Non Hai Ancora Caricato Alcun Video'
  },

  media: {
    title: 'Libreria Media',
    subtitle: 'Libreria Dei Tuoi File',
    modal_title: 'Carica Media',
    delete_warning: 'Conferma Cancella',
    delete_message:
      ' I Media Cancellati Appariranno Ancora Nelle Pagine In Cui Sono Stati Utilizzati',
    dropzone_text: 'O Trascina E Rilascia',
    delete_success: 'I Media Sono Stati Cancellati Con Successo',
    upload_file: 'Carica File',
    drag_drop: 'O Trascina E Rilascia',
    import_file: 'Importare Il/I File/I Dal Computer',
    no_media: 'Non Hai Ancora Caricato Alcun Media',
    media_type: 'Tipo Di Media',
    video: 'Video',
    image: 'Immagine',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Media Non Trovato.',
    of: 'Di',
    disclaimer: `Garantisco Che I Miei Media Non Lo Fanno:
  - Violare I Diritti Di Terzi
  - Contenere Contenuti Illegali, Compresi Quelli Diffamatori, Osceni, Indecenti, Lascivi, Pornografici, Violenti, Abusivi, Ingiuriosi, Minacciosi O Discriminatori, Anche Travestiti Da Asterischi
  - Contenere Eventuali Attacchi Personali Ad Altre Persone
  - Contenere L'eventuale Impersonificazione Di Altri Partecipanti, Personaggi Pubblici O Celebrità
  - Contengano Informazioni Personali Su Qualsiasi Persona Senza Il Consenso Di Quest'ultima E Non Violino Le Norme Sulla Protezione Dei Dati Personali In Nessuna Parte Del Mondo
  - Contenere Qualsiasi Sollecitazione Commerciale O Qualsiasi Forma Di "Spam".`,
    my_media: 'Il Mio Media',
    public_library: 'Libreria Pubblica',
    organization_library: 'Organizzazione Libreria',
    upload_from_computer: 'Aggiorna dal Computer',
    create: 'Crea',
    all: 'Tutto',
    male: 'Maschio',
    female: 'Femmina',
    processing_audio: 'Processamento Audio',
    create_annotation: 'Crea Annotazione',
    popup_over_lesson_text: `L'annotazione apparirà sulla pagina della lezione dopo il click`,
    edit_detail: 'Modifica Dettaglio',
    delete: 'Cancella',
    go_create_audio: 'Vai a Crea Audio',
    show_more_details: 'mostra più dettagli',
    show_less_details: 'mostra meno dettagli',
    drop_files: 'Lascia file e dove aggiornare',
    or: 'O',
    import_files: 'Importa file dal computer'
  },
  navigation: {
    account: 'Account',
    assessments: 'Valutazioni',
    dashboard: 'Dashboard',
    groups: 'Gestione Gruppo',
    logout: 'Disconnettiti',
    organisations: 'Organizzazioni',
    organizations_users: 'Organizzazioni & Utenti',
    reports: 'Reports',
    schedule: 'Programma',
    training: 'Formazione',
    users: 'Utenti',
    workshop: ' Il Mio Workshop',
    nowLive: 'Trasmissione'
  },

  onboarding: {
    step1_title: `Passo 1: Raccontaci un po' di te`,
    step1_subtitle:
      'Come Ti Chiami? Da Dove Vieni? Qual È Il Tuo Titolo Di Lavoro?',
    step2_title:
      'Fase 2 : Selezionare Alcune Abilità Che Si Possono Migliorare',
    step2_subtitle:
      'Diteci Poi Cosa Vorreste Capire Meglio. Forse Qualcosa Che Non Avete Ancora Capito? Un Nuovo Campo Di Studio? Cosa Fa La Persona Che Ami?'
  },

  pagebuilder: {
    title: 'Crea Lezione',
    subtitle: `E' Tempo Di Creare I Contenuti Per Il Vostro Pubblico Per Imparare Da Voi, È Possibile Immagini, Video E Infografiche`,
    select_layout: 'Selezionare Un Layout Di Pagina',
    template1: 'Vuoto',
    template2: 'Titolo E Sottotitolo',
    template3: 'Titolo E Testo',
    template4: 'Titolo, Media E Testo',
    template5: 'Titolo E Media',
    template6: 'Titolo E Quiz'
  },

  pageconstructor: {
    title: 'Crea E Clona Lezione',
    subtitle: `E' Il Momento Di Creare I Contenuti Che Il Vostro Pubblico Può Imparare Da Voi, Potete Aggiungere Immagini, Video E Infografiche`
  },

  passwordreset: {
    success_coded: `Abbiamo Inviato Un Codice Di Conferma Via E-Mail All'indirizzo Da Voi Fornito, Vi Preghiamo Di Copiare Il Codice Nel Campo Sottostante Per Impostare Una Nuova Password`,
    success_changed:
      'Hai Impostato Con Successo Una Nuova Password. Puoi Accedere Ora'
  },

  placeholders: {
    search: 'Cerrca',
    answer: 'Rispondi',
    chat: 'Dì Qualcosa…',
    code: 'Codice',
    criterion: 'Criterio',
    date_event: 'Seleziona Data E Ora',
    date_start: 'Data Inizio',
    date_expire: 'Data Scadenza',
    description: 'Descrizione',
    elements: 'Ordina Elementi',
    email: 'Email',
    feedback_correct: 'Feedback Corretto',
    feedback_incorrect: 'Feedback Incorretto',
    host: 'Ospitante',
    keywords: 'Cerca Parola/E Chiave',
    lesson_description: 'Descrizione Lezione',
    location: 'Locazione',
    minutes: 'Minuti',
    name: 'Nome',
    organiser: 'Autore',
    organization: 'Organizzazione',
    password: 'Password',
    phone: 'Telefono',
    photo: 'Foto',
    picture: 'Immagine',
    point: 'Punto',
    position: 'Posizione',
    question: 'Domanda',
    quiz: 'Nome quiz',
    search_course: 'Cerca Per Corso',
    search_media: 'Cerca Media',
    search_name: 'Cerca Per Nome',
    search_title: 'Cerca Per Titolo',
    search_training: 'Cerca Per Formazione',
    settings: 'Impostazioni',
    tags: 'Etichette',
    title: 'Titolo',
    topics: 'Argomenti',
    username: 'Nome Utente',
    keyword: 'Parole Chiave',
    max_500_characters: 'Massimo 500 caratteri',
    no_description: 'Questo File Non Ha Una Descrizione',
    no_keyword: 'Questo File Non Contiene Parole Chiave',
    no_topics: 'Questo File Non Ha Un Set Di Argomenti',
    feedback: 'Messaggio',
    contact: 'Come Possiamo Aiutare?'
  },

  publishsettings: {
    title: 'Impostazioni pubblicazioni',
    event_subtitle:
      'Aggiungete le impostazioni al vostro evento, che possono visualizzare e interagire con il vostro evento',
    assessment_subtitile:
      'Date un nome alla vostra valutazione e dite al vostro pubblico cosa si aspetta di imparare da essa',
    course_subtitle:
      'Aggiungete le impostazioni al vostro corso, che possono visualizzare e interagire con il vostro corso',
    disclaimer: `•	Registrazione
  Registrandosi Come Utente/Creando Un Account, L'utente Accetta Il Nostro [Accordo Per Gli Utenti] E Riconosce Di Aver Letto La Nostra [Informativa Sulla Privacy].,
	•	Creare Il Corso
  Utilizzando I Nostri Strumenti E Creando Il Contenuto Del Corso, L'utente Accetta Il Nostro [Accordo Con L'utente] E Riconosce Di Aver Letto La Nostra [Informativa Sulla Privacy].,
•	Crea Evento
  Utilizzando I Nostri Strumenti E Creando Un Evento, L'utente Accetta Il Nostro [Accordo Per Gli Utenti] E Riconosce Di Aver Letto La Nostra [Informativa Sulla Privacy].,
	•	Creare Una Valutazione
  Utilizzando I Nostri Strumenti E Creando Una Valutazione, L'utente Accetta Il Nostro [Accordo Per Gli Utenti] E Riconosce Di Aver Letto La Nostra [Informativa Sulla Privacy].`,

    dates_validation_error: 'Entrambe Le Date Devono Essere Compilate',
    course_dates_validation_error: 'Inserisci la data di inizio e di scadenza per questo corso.',
    emails_validation_error: 'La Lista Delle Email Non È Valida',
    specific_email_validation_error: `E' Consentita Una Sola E-Mail`,
    i_agree_to_these: `Sono D'accordo Con Queste`,
    terms_and_conditions: ' Termini E Condizioni ',
    PublicDescription: `Utenti Indipendenti E Gratuiti: (Opzioni Private E Pubbliche)Il Tuo [Corso|Evento|Valutazione] È Stato Salvato Ed È Considerato Privato Per Impostazione Predefinita. Ciò Significa Che Solo Tu Puoi Vedere Questo Contenuto. Per Pubblicare Questo Contenuto Puoi Scegliere Di Renderlo Pubblico Qui Sotto. Ciò Significa Che Il Corso Sarà Disponibile Per Tutti Gli Utenti Della Piattaforma`,
    OrganisationsDescription: `Utenti Dell'org: (Invece Di ""Finire"" Utilizzare ""Pubblicare"" E Portarli Alla Pagina Di Pubblicazione Come Gli Altri Utenti, Ma Senza Alcuna Delle Opzioni Di Pubblicazione) Il Tuo [Corso|Evento|Valutazione] È Stato Salvato Ed È Privato. Questo Significa Che Solo Tu E Gli Amministratori Della Tua Organizzazione Potete Vederlo. In Quanto Utente, Non Sei In Grado Di Pubblicare I Tuoi Contenuti All'interno Della Tua Organizzazione In Quanto Ciò Richiede Diritti Di Amministratore. Contattate Uno Dei Vostri Amministratori E Chiedete Loro Di Pubblicare I Vostri Contenuti Pubblicamente, All'intera Organizzazione, A Gruppi Specifici All'interno Della Vostra Organizzazione O A Specifici Utenti`,
    OrganisationGroupsDescription: `Org Admins: (Per I Contenuti Realizzati All' interno Dell'organizzazione: Privato, Pubblico, Organizzazione, Gruppi, Utenti Specifici):Questo [Corso|Evento|Valutazione] È Stato Salvato Ed È Considerato Privato Per Impostazione Predefinita. Ciò Significa Che Solo Tu (E Il Creatore Del Contenuto) Puoi Vedere Questo Contenuto . Per Pubblicare Questo Contenuto È Possibile Selezionare Una Delle Opzioni Seguenti. Pubblicare Il Tuo Corso Al Pubblico Significa Che Sarà Disponibile Per Tutti Gli Utenti Della Piattaforma - Compresi Quelli Al Di Fuori Della Tua Organizzazione. Pubblicarlo All'organizzazione Significa Che Tutti Gli Utenti All'interno Dell'organizzazione Potranno Vederlo. Potete Anche Pubblicarlo A 1 O Più Gruppi, Il Che Significa Che Solo Gli Utenti All'interno Di Tali Gruppi Potranno Vederlo.  Infine, Avete La Possibilità Di Pubblicarlo A Specifici Utenti All'interno E All'esterno Della Vostra Organizzazione Utilizzando L'indirizzo E-Mail Del Loro Account Sharelook`,
    SpecificUsersDescription: `Utenti Indipendenti A Pagamento: (Utenti Privati, Pubblici E Specifici)Il Tuo [Corso|Evento|Valutazione] È Stato Salvato Ed È Considerato Privato Per Impostazione Predefinita. Ciò Significa Che Solo Tu Puoi Vedere Questo Contenuto. Per Pubblicare Questo Contenuto È Possibile Selezionare Una Delle Opzioni Seguenti. Pubblicare Il Tuo Corso Al Pubblico Significa Che Sarà Disponibile Per Tutti Gli Utenti Della Piattaforma. L'opzione Utenti Specifici Ti Permetterà Di Condividere Il Tuo Corso Con Utenti Specifici Utilizzando L'indirizzo E-Mail Associato Al Loro Account Sharelook.`
  },

  quiz: {
    quiz_empty: 'Non Hai Ancora Creato Un Quiz',
    questions_empty: 'Non Hai Ancora Creato Una Domanda'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Giappone',
    asia_pacific_s_korea: 'Corea del Sud',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgio',
    eu_germany: 'Germania',
    eu_ireland: 'Irlanda',
    south_america_brazil: 'Brasile',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina Del Sud',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Reports',
    workshop_report: 'Workshop Report',
    user_report: 'Report Utente',
    organization_workshop: 'Organizzazione workshop',
    course: 'Corso',
    live_event: 'Evento Diretta',
    workShop_graph: 'Grafico workshop',
    organization_account: 'Organizzazione account',
    all: 'Tutti',
    name: 'Nome',
    id_number: 'Numero ID',
    email: 'Email',
    search_user_report: 'Cercare Report Utente',
    participant: 'Partecipante',
    participants: 'Partecipanti',
    host: 'Ospitante',
    username: 'Nome utente',
    event: 'Evento',
    quiz: 'Quiz',
    assessment: 'Valutazione',
    time: 'Tempo',
    no_recent_activity: 'Nessuna Attività Recente',
    workshops: 'Workshops',
    courses: 'Corsi',
    live_events: 'Eventi Diretta',
    live_assessments: 'Valutazioni Diretta',
    quizzes: 'Quiz',
    overview: 'Panoramica',
    by: 'Da',
    views: 'Visualizzazioni',
    status: 'Stato',
    poll: 'Sondaggio',
    comment: 'Commento',
    comments: 'Commenti',
    no_comments: 'Nessun Commento',
    no_polls: 'No Sondaggi',
    live_date: 'Data Diretta',
    score: 'Punteggio',
    question: 'Domanda',
    submit: 'Invia',
    recent_activity: 'Attività recente',
    ago: 'Fa',
    no_data_found: 'Nessun dato trovato',
    start_end_live: 'Inizio/ Fine diretta',
    join_leave_date: 'Unisciti/Esci',
    watched_time: 'Tempo Guardato',
    complete: 'Completo',
    in_complete: 'In Completo',
    today: 'Oggi',
    seven_days: 'Giorni',
    last_month: `'L'ultimo Mese`,
    one_year: '1 Anno',
    all_time: 'Tutto il Tempo',
    report: 'Report',
    from_date: 'Dalla Data',
    to_date: 'Alla Data',
    all_workshop: 'Tutto il Workshop',
    all_participants: 'Tutti i Partecipanti',
    live_assessment: 'Valutazione Diretta',
    users: 'Utenti',
    download: 'Scarica',
    recent: 'Recente',
    WorkShop: 'Workshop',
    Activity: 'Attività',
    created_date: 'Crea data',
    lessons: 'Lezioni',
    lesson: 'Lezione',
    completed: 'Completato',
    report_download: 'Scarica report',
    this_month: 'Questo mese',
    search_course: 'Cerca corso',
    participants_graph: 'Grafico partecipanti',
    viewed: 'Visto',
    enrolled: 'Iscritto',
    description: 'Descrizione',
    topic: 'Argomento',
    analytic: 'Analitica',
    quiz_list: 'Lista quiz',
    select_one: 'Seleziona Uno',
    group_status: 'Stato gruppo',
    duration_min: 'Durata(min)',
    submit_poll: 'Invia sondaggio',
    download_events: 'Scarica Eventi',
    search_event: 'Cerca evento',
    duration: 'Durata',
    total_participants: 'Partecipanti totali',
    message: 'Messaggio',
    avg_message: 'Messaggio medio',
    per_message: 'UNA PERCENTUALE DI MESSAGGI/EVENTO'
  },

  signup: {
    success_step1: `Abbiamo Inviato Un Codice Di Verifica Via E-Mail All'indirizzo Da Voi Fornito, Vi Preghiamo Di Copiare Il Codice Nel Campo Sottostante Per Confermare La Vostra Registrazione`,
    success_step2: 'Grazie. Sei Registrato Con Successo',
    privacy:
      'Accetto I Termini E Le Condizioni <1> Di Sharelook</1> E <3> Sulla Privacy</3>'
  },

  stream: {
    emotion_impressive: 'Impressionante',
    emotion_unimpressive: 'Impressionante',
    message_not_started: 'Prossimamente',
    message_running: 'Diretta',
    message_processing:
      'Attualmente Stiamo Elaborando La Registrazione Dal Vivo Per La Riproduzione. Si Prega Di Controllare Più Tardi Per Visualizzare Il Video E Continuare Ad Aggiungere Valutazioni E Feedback'
  },

  tabs: {
    audience: 'Pubblico',
    course: 'Panoramica Corso',
    details: 'Dettagli Evento Diretta',
    description: 'Descrizione',
    host: 'Ospitante',
    lesson: 'Panoramica Lezione',
    lessons: 'Lezioni',
    overview: 'Panoramica',
    page: 'Costruttore Pagina',
    publish: 'Pubblica',
    settings: 'Impostazioni Pubblicazione',
    total_views: 'Totale Visioni',
    live_participates: 'Partecipanti In Diretta',
    live_chats: 'Chat In Diretta',
    live_quiz: 'Sondaggi In Diretta',
    trainer_rating: 'Valutazione Allenatore',
    trainer_times: 'Tempi Allenatore',
    courses_quizzes: 'Quiz Dei Corsi',
    user_list: 'Lista Utente',
    discussion: 'Discussione',
    notes: 'Le Mie Note'
  },

  topics: {
    sales_training: 'Formazione Alla Vendita',
    negotiation_training: 'Formazione Alla Negoziazione',
    cross_cultural_awareness: 'Consapevolezza Interculturale',
    networking_skills: 'Abilità Di Networking',
    software_architecture: 'Architettura Software',
    project_management: 'Gestione Progetto',
    digital_transformation: 'Trasformazione Digitale',
    it_consulting: 'Consulenza IT',
    management_consulting: 'Consulenza Gestione',
    hr_consulting: 'Consulenza HR',
    internet_of_things: 'Internet of Things (IoT)',
    cybersecurity: 'Cybersicurezza',
    privacy_and_gdrp: 'Privacy E GDPR'
  },

  training: {
    title: 'Formazione',
    title_assessment: 'Valutazioni',
    subtitle: 'Corsi Ed Eventi In Diretta',
    enrolled_title: 'Corsi Iscritti Ed Eventi In Diretta',
    enrolled_subtitle: 'Corsi Ed Eventi In Diretta Cui Ti Sei Iscritto',
    enrolled_message: 'Attualmente Non Sei Iscritto Ad Alcun Corso O Evento',
    past_live_event_title: 'Eventi Diretta Passati',
    past_live_event_subTitle: 'Eventi Diretta Finiti',
    past_live_event: 'Attualmente Non Ci Sono Eventi Passati In Diretta',
    recomended_title: 'Corsi Consigliati Ed Eventi Diretta',
    now_live_event_title: 'Ora In Diretta',
    now_live_event_subTitle:
      'Eventi Che Sono In Diretta O Lo Saranno Molto Presto',
    now_live_event: `Attualmente Non C'è Nessun Evento In Diretta`,
    webinar_event_title: 'Canale Webinar',
    webinar_event_subTitle: 'Webinari Finiti',
    webinar_event: 'Attualmente Non Ci Sono Webinar',
    p2p_event_title: 'Sessioni Di Coaching',
    p2p_event_subTitle: 'Sessioni Di Coaching Finite',
    p2p_event: 'Attualmente Non Ci Sono Sessioni Di Coaching',

    now_live_assessment_title: 'Ora In Diretta',
    now_live_assessment_subTitle:
      ' Valutazione Che Sono In Diretta O Lo Saranno Molto Presto',
    now_live_assessment_message: `Attualmente Non C'è Una Valutazione In Diretta`,

    upcoming_assessment_title: 'Prossime Valutazioni In Diretta',
    upcoming_assessment_subtitle: 'Prossime Valutazioni In Diretta',
    upcoming_assessment_message:
      'Al Momento Non È Prevista Una Valutazione In Diretta',

    past_live_assessment_title: 'Valutazioni In Diretta Del Passato',
    past_live_assessment_subTitle: 'Valutazioni In Diretta Finite',
    past_live_assessment_message:
      'Attualmente Non Ci Sono Valutazioni In Diretta Del Passato',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      ' Abbiamo curato corsi ed eventi dal vivo sulla base dei vostri <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Ricerca Formazione',
    search_assessment: 'Ricerca Valutazione',
    recomended_message: 'Attualmente Non Ci Sono Corsi Ed Eventi Consigliati'
  },

  warnings: {
    delete: 'Sei Sicuro?'
  },

  workshop: {
    title: 'Il Mio Workshop',
    subtitle: 'Creare Un Corso O Ospitare Un Evento Dal Vivo',
    new_course: 'Creare Un Nuovo Corso',
    new_event: 'Creare Un Nuovo Evento Dal Vivo',
    new_assessment: 'Creare Una Nuova Valutazione Dal Vivo',
    courses_title: 'Corsi Creati Ed Eventi Dal Vivo',
    courses_subtitle:
      'Modifica E Pubblica Il Corso Creato E Pianifica Eventi Dal Vivo',
    tags_course: 'Corso',
    tags_live: 'Evento Diretta',
    tags_assessment: 'Valutazione Diretta'
  },

  help_center: {
    sidebar: {
      title: ' Come Possiamo Aiutarti?',
      back_to: 'Dashboard'
    },
    menu: {
      help_center: 'Centro Aiuti',
      whats_new: `Cosa C'è Di Nuovo`,
      feedback: 'Risposta',
      feedback_title: 'Invia Un Feedback A Sharelook',
      terms_and_conditions: 'Termini E Condizioni',
      privacy_policy: 'Informativa Privacy',
      contact_us: 'Contattaci'
    },
    get_started: {
      title: 'Iniziare Con Lo Share Look',
      description: {
        main:
          'Abbiamo Integrato Il Video In Diretta In Un Costruttore Corso Facile Da Usare',
        tagline: `Con Il Sistema Di Trasmissione In Diretta Brevettato Da Sharelook, È Possibile Creare Coinvolgimento, Automatizzare L'apprendimento E Massimizzare La Condivisione Delle Conoscenze`
      }
    },
    whats_new: {
      title: 'Iniziare Con Lo Share Look',
      description: {
        main: `Sapevate Che Si Può Creare L'apprendimento Dello Stile Di Storytelling Breve Tempo E Non È Così Costoso?  Dovresti Combinare Il Costruttore Del Corso Sharelook E I Rispettivi Talenti. Puoi Chiederci "COME"`,
        tagline: ''
      }
    },
    create_workshop: 'Come Creare Un Workshop',
    create_course: 'Come Creare Un Corso',
    create_user: 'Come Creare Un Utente',
    create_group: 'Come Creare Un Gruppo',
    create_webinar: 'Come Creare Un Webinar',
    create_live_event: 'Come Creare Un Evento Diretta',
    create_live_assessment: 'Come Creare Una Valutazione Diretta',
    create_live_on_mobile: 'Crea Diretta Su Mobile',
    personalize_profile: 'Personalizzare Un Profilo',
    manage_group: 'Gestisci gruppo',
    report: 'Report',
    add_annotations: 'Come Aggiungere Annotazioni/Popups',
    add_audio: 'Come Aggiungere Audio',
    add_header_and_footer: 'Aggiungere Intestazione E Piè Di Pagina',
    add_image: 'Come Aggiungere Immagine',
    add_quiz_content: 'Come Aggiungere Contenuti Del Quiz',
    add_text_content: 'Come Aggiungere Contenuti Testuali',
    add_user: 'Come Aggiungere Un Utente',
    add_video: 'Come Aggiungere Video',
    clone_course: 'Come Clonare Corso',
    find_live_broadcast: 'Come Trovare Trasmissione Diretta',
    contact_us: {
      title: 'Contattaci',
      subject_placeholder: 'Inserisci Una Materia*',
      content_placeholder: 'Inserisci Un Messaggio*',
      subject_required: '*Materia È Richeista',
      content_required: '*Messaggio È Richiesto',
      submit: 'Invia',
      cancel: 'Cancella',
      sent: 'Sent'
    },
    feedback: {
      title: 'Invia Un Feedback A Sharelook',
      attach_title: 'Allega Un File',
      choose: 'Scegli Un File',
      detail: 'Il File Sarà Condiviso Con Il Team Di Supporto',
      content_placeholder: 'Inserisci Messaggio*',
      content_required: '*Messaggio È Richiesto',
      submit: 'Invia',
      cancel: 'Cancella',
      sent: 'Inviato'
    }
  },
  discussion: {
    join_discussion: 'Partecipare Alla Discussione'
  },
  notes: {
    title: 'Le Mie Note',
    add_note: 'Aggiungi Nuova Nota'
  }
}
